import React from "react";
import PropTypes from "prop-types";

const PurposeAndBalanceIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill={props.fill}
      style={props.style}
      viewBox="0 0 2000 2000"
    >
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1103.000000,2001.000000 
	C736.833313,2001.000000 371.166656,2000.993286 5.500025,2001.093018 
	C1.750918,2001.093994 0.906737,2000.249023 0.907281,1996.500000 
	C1.003694,1332.833374 1.003694,669.166687 0.907281,5.500014 
	C0.906737,1.751003 1.751000,0.906735 5.500013,0.907280 
	C669.166687,1.003704 1332.833374,1.003704 1996.500000,0.907280 
	C2000.249023,0.906735 2001.093262,1.751001 2001.092651,5.500013 
	C2000.996338,669.166687 2000.996216,1332.833374 2001.092651,1996.500000 
	C2001.093140,2000.249023 2000.249146,2001.094482 1996.500000,2001.093140 
	C1698.833374,2000.991699 1401.166626,2001.000000 1103.000000,2001.000000 
z"
      />
      <path
        fill="#0B8E36"
        opacity="1.000000"
        stroke="none"
        d="
M1049.382324,1405.576904 
	C1049.148315,1407.647095 1048.989136,1409.351929 1048.893188,1411.481689 
	C1048.001343,1413.601807 1048.722534,1415.456787 1048.341553,1417.589600 
	C1048.082153,1419.614258 1047.931152,1421.266235 1047.844238,1423.328613 
	C1047.165039,1425.172119 1047.627197,1426.728027 1047.355957,1428.586792 
	C1047.106689,1430.636963 1046.953857,1432.319580 1046.866943,1434.420776 
	C1046.103638,1436.223877 1046.656128,1437.758545 1046.382324,1439.576904 
	C1046.148315,1441.647217 1045.989136,1443.352173 1045.893066,1445.481934 
	C1045.063232,1447.256348 1045.674927,1448.779297 1045.396729,1450.570068 
	C1044.993042,1453.035156 1043.421021,1452.867676 1041.531494,1452.864746 
	C1036.449707,1451.914551 1031.675049,1452.782104 1026.498779,1452.385498 
	C1020.801636,1452.134033 1015.545227,1451.960693 1009.849609,1451.843262 
	C1004.608093,1450.975830 999.754211,1451.747925 994.489014,1451.358887 
	C989.083252,1451.101807 984.121094,1450.944092 978.711731,1450.847900 
	C973.513550,1449.945312 968.706726,1450.768921 963.493652,1450.372314 
	C958.037598,1450.131348 953.023254,1449.978882 947.551208,1449.891357 
	C942.060669,1448.942871 936.967285,1449.760864 931.474976,1449.343750 
	C927.406616,1448.187622 923.350525,1450.298706 919.781006,1447.332397 
	C919.349731,1418.283569 919.601379,1389.641968 919.512146,1361.000732 
	C919.501221,1357.504150 919.594910,1354.006836 919.274902,1350.050903 
	C919.051697,1316.015503 919.001831,1282.440186 918.833984,1248.406250 
	C918.261292,1229.986572 918.612305,1212.022949 918.524475,1194.060791 
	C918.450439,1178.921753 918.578552,1163.782349 918.279541,1148.189575 
	C918.051636,1114.451782 918.012512,1081.167847 917.870117,1047.422852 
	C917.206421,1039.993652 917.556519,1033.013306 917.534851,1026.039551 
	C917.452698,999.604858 917.585022,973.169922 917.265015,946.286255 
	C917.034363,912.515564 917.002380,879.193909 916.855286,845.413269 
	C916.224548,832.634949 916.590393,820.310059 916.531067,807.988037 
	C916.430786,787.162842 916.605286,766.336975 916.274902,745.051025 
	C916.045288,711.013123 915.989136,677.435913 915.812744,643.400024 
	C915.286255,617.993713 915.627197,593.044312 915.516602,568.095947 
	C915.480469,559.945068 915.577454,551.793945 915.279541,543.189514 
	C915.125488,531.495667 915.118225,520.255005 915.244507,509.015869 
	C915.261353,507.518463 914.061401,505.080139 917.631470,504.858643 
	C921.177246,504.214172 924.341125,504.721771 927.872070,504.268311 
	C931.564514,504.044128 934.865417,503.997223 938.609070,503.833160 
	C942.159180,503.248627 945.291931,503.695709 948.784119,503.261353 
	C952.498108,503.021240 955.833557,502.976105 959.613892,502.811646 
	C963.150269,502.279999 966.261780,502.675323 969.725891,502.253113 
	C973.451050,502.006287 976.808533,501.968719 980.612427,501.811768 
	C983.896057,501.251678 986.765442,501.743530 990.007751,501.250580 
	C993.657837,501.058807 996.906311,501.015686 1000.596680,500.869629 
	C1004.169312,500.182892 1007.338745,500.736389 1010.871582,500.268402 
	C1014.562378,500.050537 1017.861145,500.010040 1021.602783,499.854858 
	C1025.177368,499.214203 1028.341309,499.721741 1031.872314,499.268311 
	C1035.564941,499.044159 1038.866211,498.997253 1042.609985,498.833130 
	C1046.159668,498.248749 1049.292236,498.695648 1052.784058,498.261353 
	C1056.498047,498.021301 1059.833496,497.976166 1063.613892,497.811707 
	C1067.150269,497.279999 1070.261719,497.675323 1073.725830,497.253174 
	C1077.450928,497.006317 1080.808594,496.968781 1084.612427,496.811768 
	C1087.895996,496.251740 1090.765259,496.743439 1094.007446,496.250641 
	C1097.657349,496.058868 1100.905640,496.015686 1104.595947,495.869690 
	C1108.168823,495.182800 1111.338623,495.736420 1114.871704,495.268372 
	C1118.562500,495.050507 1121.861206,495.010010 1125.602783,494.854828 
	C1129.152344,494.220245 1132.289673,494.709015 1135.783447,494.261414 
	C1139.495972,494.027771 1142.829346,493.989136 1146.607666,493.833221 
	C1150.159668,493.248749 1153.292236,493.695648 1156.784058,493.261353 
	C1160.498047,493.021240 1163.833496,492.976135 1167.613892,492.811646 
	C1171.150269,492.279999 1174.261719,492.675323 1177.725830,492.253174 
	C1181.112305,492.020142 1184.131104,491.996368 1187.593994,491.869720 
	C1191.204346,491.159424 1194.417358,491.784515 1198.000977,491.253784 
	C1201.657471,491.058746 1204.905762,491.015625 1208.595947,490.869690 
	C1212.168823,490.182800 1215.338623,490.736420 1218.871704,490.268372 
	C1222.562500,490.050507 1225.861206,490.010010 1229.602783,489.854828 
	C1233.152344,489.220245 1236.289673,489.709015 1239.783447,489.261414 
	C1243.495972,489.027740 1246.829346,488.989136 1250.607666,488.833221 
	C1254.159668,488.248749 1257.292236,488.695648 1260.784058,488.261353 
	C1264.498047,488.021271 1267.833496,487.976135 1271.613892,487.811646 
	C1275.150269,487.279999 1278.261719,487.675323 1281.725830,487.253174 
	C1285.112183,487.020142 1288.130981,486.996399 1291.593750,486.869751 
	C1295.204346,486.159424 1298.417358,486.784515 1302.000977,486.253784 
	C1305.661621,486.057678 1308.913818,486.013550 1312.605835,485.854797 
	C1316.177246,485.214172 1319.341187,485.721771 1322.872192,485.268311 
	C1326.562500,485.050507 1329.861206,485.010010 1333.602783,484.854828 
	C1337.152344,484.220245 1340.289673,484.709015 1343.783447,484.261383 
	C1347.495972,484.027740 1350.829346,483.989136 1354.607666,483.833191 
	C1358.143799,483.252289 1361.259521,483.688293 1364.725342,483.253235 
	C1368.413696,483.013885 1371.733887,482.983917 1375.504150,482.892792 
	C1380.699707,482.096893 1385.482544,482.777557 1390.626953,482.233093 
	C1392.394287,482.002625 1393.773926,481.994873 1395.564697,481.939240 
	C1401.040405,481.010376 1406.153198,481.816589 1411.623535,481.232880 
	C1413.392822,481.002228 1414.771118,480.994080 1416.559326,480.933228 
	C1422.034058,480.017883 1427.145264,480.814789 1432.612671,480.227600 
	C1434.381592,479.990021 1435.761841,479.978699 1437.552246,479.910278 
	C1442.719727,479.095551 1447.515991,479.759369 1452.685059,479.258209 
	C1454.765869,479.024658 1456.447510,478.996185 1458.545654,478.910461 
	C1463.711670,478.091705 1468.500610,478.765656 1473.655762,478.245026 
	C1475.739502,478.003601 1477.430054,477.976685 1479.538574,477.887482 
	C1484.701294,477.103912 1489.482178,477.775208 1494.623535,477.230255 
	C1496.390747,476.999207 1497.771851,476.993164 1499.564331,476.939240 
	C1505.036377,476.006683 1510.145874,476.820160 1515.608398,476.224579 
	C1517.379028,475.992584 1518.762573,475.989227 1520.557739,475.933228 
	C1526.034058,475.017883 1531.145264,475.814789 1536.612671,475.227631 
	C1538.381592,474.990051 1539.761841,474.978729 1541.552246,474.910339 
	C1546.719727,474.095551 1551.515991,474.759369 1556.685059,474.258209 
	C1558.765869,474.024628 1560.447510,473.996155 1562.545654,473.910461 
	C1567.711670,473.091705 1572.500610,473.765656 1577.655762,473.245026 
	C1579.739502,473.003571 1581.430054,472.976654 1583.538574,472.887482 
	C1588.701294,472.103912 1593.482178,472.775208 1598.623535,472.230225 
	C1600.390747,471.999207 1601.771851,471.993164 1603.564331,471.939209 
	C1609.036377,471.006683 1614.145874,471.820160 1619.608398,471.224579 
	C1621.379028,470.992584 1622.762573,470.989227 1624.557739,470.933228 
	C1629.722290,470.061432 1634.519897,470.775940 1639.688477,470.261780 
	C1641.769409,470.029053 1643.449707,469.998352 1645.546143,469.910431 
	C1657.484253,468.591431 1657.484253,468.591431 1657.484375,479.630951 
	C1657.484375,482.453156 1657.484131,485.275330 1657.484619,488.589355 
	C1657.454102,516.418945 1657.543701,543.756775 1657.270630,571.558960 
	C1657.067749,585.369324 1657.034058,598.715149 1656.999634,612.529541 
	C1656.028564,614.713928 1656.510864,616.584229 1656.508301,618.375122 
	C1656.451660,657.618164 1656.534546,696.861267 1656.303955,736.576294 
	C1656.107178,750.713867 1656.053101,764.379456 1655.991577,778.512329 
	C1655.043091,780.702515 1655.509888,782.570496 1655.507324,784.363953 
	C1655.451782,823.610657 1655.534546,862.857422 1655.303955,902.576294 
	C1655.107178,916.713867 1655.053101,930.379456 1654.991577,944.512329 
	C1654.043091,946.702515 1654.509888,948.570496 1654.507324,950.363953 
	C1654.451782,989.610718 1654.534546,1028.857544 1654.303955,1068.576416 
	C1654.107178,1082.714233 1654.053101,1096.379883 1653.991577,1110.513062 
	C1653.043091,1112.703247 1653.510132,1114.571167 1653.507446,1116.364502 
	C1653.450439,1155.610107 1653.537598,1194.855713 1653.292114,1234.570312 
	C1653.086670,1248.698486 1653.033325,1262.357544 1652.971680,1276.481934 
	C1652.063232,1278.679443 1652.508911,1280.544312 1652.506348,1282.341187 
	C1652.450806,1321.594482 1652.537476,1360.847778 1652.292114,1400.570312 
	C1652.028442,1423.303833 1651.865845,1445.568237 1651.865234,1467.832642 
	C1651.865112,1470.870605 1651.377319,1472.684082 1647.435791,1471.999634 
	C1639.305786,1470.832886 1631.557739,1471.844238 1623.406616,1471.280029 
	C1620.622192,1471.072632 1618.275024,1471.025879 1615.488037,1470.974121 
	C1607.668213,1469.885254 1600.240723,1470.811523 1592.403076,1470.295166 
	C1589.603760,1470.097900 1587.245239,1470.049072 1584.444092,1469.999634 
	C1576.305908,1468.834961 1568.557983,1469.844727 1560.409790,1469.270508 
	C1557.626343,1469.061279 1555.277344,1469.020264 1552.488281,1468.974121 
	C1544.668213,1467.885254 1537.240723,1468.811523 1529.403076,1468.295166 
	C1526.609131,1468.097290 1524.256104,1468.047974 1521.461548,1467.990967 
	C1514.653320,1466.804932 1508.218384,1467.888062 1501.477051,1467.109863 
	C1507.650757,1446.930420 1514.152710,1427.037476 1520.714233,1407.163940 
	C1525.057739,1394.008789 1529.486938,1380.881714 1533.946777,1367.380859 
	C1534.959473,1365.299927 1534.487305,1363.434448 1534.492065,1361.643677 
	C1534.553101,1338.724609 1534.465332,1315.805420 1534.696289,1292.418945 
	C1534.899170,1279.295532 1534.959595,1266.639404 1535.028442,1253.518066 
	C1535.937134,1251.320923 1535.490845,1249.456421 1535.493652,1247.659790 
	C1535.549805,1211.405762 1535.462402,1175.151733 1535.708008,1138.429199 
	C1537.827515,1125.246338 1533.362061,1113.985718 1528.325195,1102.703003 
	C1522.274414,1089.148560 1516.795532,1075.339478 1511.005371,1061.667603 
	C1505.857910,1049.512695 1500.648438,1037.383911 1495.419067,1025.263916 
	C1491.351807,1015.837036 1487.034668,1006.512085 1483.233521,996.980347 
	C1482.322632,994.696106 1481.033813,993.558899 1479.130615,992.570068 
	C1455.265015,980.170166 1431.422485,967.725586 1407.535767,955.366150 
	C1390.565918,946.585693 1373.537964,937.917053 1356.188843,929.106018 
	C1355.355591,928.153381 1355.642822,927.147583 1355.219482,925.917542 
	C1350.896362,909.344238 1346.697754,893.104004 1342.446533,876.877502 
	C1340.382080,868.997498 1338.271973,861.128418 1336.069214,853.286133 
	C1335.358276,850.754822 1335.664551,849.569214 1338.605225,848.760864 
	C1347.409058,846.340698 1355.960571,843.110657 1364.566162,840.039124 
	C1376.110718,835.918640 1382.052490,827.979004 1383.141235,815.647705 
	C1383.193970,815.084290 1383.290161,814.916687 1383.384277,814.459351 
	C1383.657715,812.810120 1383.932983,811.450806 1384.151367,809.673584 
	C1384.565063,808.453247 1384.507324,807.556885 1384.646484,806.361023 
	C1384.892334,805.008240 1385.043945,803.973267 1385.131348,802.549438 
	C1385.791748,801.097961 1385.402588,799.879272 1385.631836,798.393127 
	C1385.884766,796.436646 1386.053345,794.822449 1386.163330,792.806396 
	C1386.756470,790.920654 1386.420044,789.342468 1386.630127,787.429871 
	C1386.868408,785.020569 1387.020630,782.989685 1387.108154,780.526184 
	C1388.044434,777.733704 1387.257446,775.250183 1387.642822,772.443115 
	C1387.898438,768.787842 1388.056396,765.530273 1388.157471,761.841553 
	C1388.989258,757.269592 1388.268433,753.071533 1388.656250,748.473877 
	C1388.915649,740.412964 1389.064575,732.787170 1389.152100,724.712769 
	C1389.993408,713.007385 1389.361572,701.734924 1389.267456,690.029663 
	C1389.045288,682.012573 1388.989258,674.435547 1388.812866,666.399780 
	C1388.266479,661.841797 1388.686768,657.726746 1388.264160,653.230469 
	C1388.021240,649.501831 1387.976196,646.166321 1387.811768,642.385986 
	C1387.292725,639.507812 1387.669556,637.049561 1387.250244,634.258545 
	C1387.020264,631.874878 1386.996582,629.842957 1386.869873,627.385986 
	C1386.230835,625.152771 1386.716064,623.280273 1386.256104,621.097168 
	C1386.052612,619.080688 1386.013428,617.423950 1385.870605,615.364197 
	C1385.273193,613.514221 1385.670898,612.001587 1385.242310,610.221191 
	C1385.005371,608.520081 1384.966797,607.133057 1384.810547,605.344971 
	C1384.422241,604.067749 1384.628662,603.125305 1384.215332,601.929749 
	C1384.071655,600.625793 1384.031250,599.646790 1383.878906,598.315186 
	C1383.378418,597.101685 1383.637573,596.134033 1383.217041,594.932861 
	C1383.059814,593.622192 1383.007568,592.639709 1382.836182,591.305298 
	C1382.525391,590.373413 1382.527832,589.745239 1382.199707,588.884094 
	C1381.917358,586.951111 1381.863770,585.277771 1381.483521,583.682312 
	C1375.874390,560.145020 1374.513550,559.551636 1349.657471,554.860291 
	C1349.084351,554.806030 1348.916748,554.709961 1348.459351,554.615723 
	C1346.809204,554.343201 1345.448853,554.068848 1343.670166,553.849121 
	C1342.731323,553.682556 1342.205444,553.480103 1341.351807,553.409058 
	C1339.774170,553.173645 1338.476318,552.976990 1336.786865,552.834534 
	C1335.537720,552.520203 1334.629517,552.463196 1333.381958,552.367432 
	C1331.758667,552.114624 1330.467529,551.945618 1328.788574,551.834473 
	C1327.230103,551.357666 1325.974365,551.523438 1324.392578,551.340942 
	C1322.709351,551.081299 1321.381348,550.929504 1319.656494,550.842468 
	C1318.153809,550.278015 1316.930542,550.560486 1315.407227,550.381531 
	C1313.352295,550.148254 1311.647461,549.989136 1309.517822,549.893005 
	C1307.404785,549.004272 1305.559082,549.716492 1303.428711,549.369995 
	C1301.020874,549.131714 1298.989624,548.979431 1296.525757,548.891663 
	C1294.074097,547.966675 1291.915283,548.739197 1289.448975,548.383728 
	C1286.365845,548.147278 1283.673706,547.986938 1280.537354,547.891357 
	C1277.068237,546.949280 1273.945190,547.759338 1270.467041,547.371460 
	C1265.753174,547.117981 1261.454346,546.952087 1256.709961,546.847778 
	C1249.174683,545.925537 1242.045776,546.782288 1234.489990,546.344299 
	C1225.646973,546.171448 1217.255981,546.109741 1208.406250,546.166016 
	C1201.543823,546.775757 1195.127319,546.288635 1188.313477,546.747009 
	C1184.551147,546.987305 1181.195923,547.018311 1177.394043,547.166687 
	C1174.772339,547.755615 1172.548340,547.252197 1169.979858,547.755615 
	C1167.652954,547.940063 1165.714111,547.983337 1163.368652,548.129883 
	C1161.452026,548.757385 1159.853027,548.259277 1157.962646,548.765076 
	C1155.972290,548.954285 1154.349365,549.014160 1152.335205,549.190735 
	C1151.097534,549.573914 1150.192871,549.388489 1149.043701,549.773926 
	C1147.394287,549.972717 1146.046021,550.039551 1144.312744,550.238403 
	C1143.371582,550.457764 1142.801880,550.475281 1142.008789,550.796875 
	C1134.066772,551.501221 1126.768555,553.567505 1119.724731,556.621460 
	C1110.754150,560.510681 1109.124634,568.670105 1107.882812,577.435303 
	C1107.375854,578.595520 1107.516235,579.486267 1107.352783,580.646423 
	C1107.100098,581.965027 1106.940918,582.973328 1106.844482,584.360962 
	C1106.271729,585.855042 1106.568726,587.091003 1106.340454,588.617310 
	C1106.089355,590.317627 1105.945679,591.673279 1105.867554,593.434021 
	C1105.103638,595.223511 1105.656128,596.758301 1105.382324,598.576660 
	C1105.138794,601.284302 1104.970093,603.626648 1104.867554,606.403564 
	C1103.984863,609.562744 1104.734131,612.385681 1104.342773,615.555054 
	C1104.097656,619.641418 1103.962158,623.321716 1103.891479,627.454224 
	C1102.859253,634.926514 1103.811890,641.994263 1103.385986,649.486694 
	C1103.214966,662.337097 1103.122314,674.732483 1103.144775,687.586853 
	C1103.808960,696.444824 1103.270996,704.855896 1103.747803,713.675659 
	C1103.979736,718.769775 1104.003174,723.446289 1104.129883,728.580933 
	C1104.827881,732.832581 1104.257935,736.658447 1104.729614,740.862366 
	C1104.949585,744.562805 1104.990112,747.861328 1105.145142,751.602783 
	C1105.772583,754.822266 1105.294556,757.632629 1105.739746,760.790161 
	C1105.964844,763.501709 1105.996094,765.841125 1106.130249,768.609741 
	C1106.809204,771.210266 1106.228638,773.448364 1106.755615,776.019897 
	C1106.955933,778.682007 1107.014282,780.954895 1107.190063,783.643066 
	C1107.674072,785.546387 1107.324463,787.079956 1107.751343,788.918152 
	C1107.947266,790.919006 1107.986572,792.575928 1108.129395,794.635864 
	C1108.740601,796.518311 1108.298340,798.073120 1108.750244,799.915833 
	C1108.963135,801.926208 1109.018433,803.590210 1109.190430,805.655884 
	C1109.625488,807.191101 1109.373047,808.368958 1109.765747,809.802002 
	C1109.975464,811.151611 1109.995117,812.210693 1110.123779,813.653931 
	C1110.696289,815.190430 1110.322632,816.431396 1110.758545,817.930908 
	C1110.943359,819.273743 1110.979858,820.288086 1111.124634,821.669861 
	C1111.621582,822.898315 1111.362427,823.865967 1111.782959,825.067139 
	C1111.929810,826.377869 1111.971436,827.360413 1112.136230,828.693237 
	C1112.597778,829.862976 1112.390869,830.759094 1112.774658,831.877014 
	C1112.990845,833.213318 1113.049316,834.266968 1113.239014,835.696289 
	C1113.454834,836.598511 1113.473633,837.137268 1113.808105,837.868103 
	C1114.033936,839.206665 1114.112549,840.321899 1114.403564,841.800903 
	C1114.611450,842.348816 1114.607056,842.533020 1114.767090,842.939331 
	C1114.968628,843.896423 1115.005859,844.631226 1115.179443,845.710388 
	C1115.460449,846.576233 1115.472290,847.126526 1115.806396,847.865417 
	C1116.715088,854.394470 1118.944946,860.264526 1121.236450,866.120667 
	C1124.197754,873.688354 1129.678711,877.769470 1138.210571,878.161743 
	C1139.770020,878.642334 1141.025635,878.476562 1142.607422,878.659058 
	C1151.014160,879.598877 1159.075562,879.127502 1167.593750,878.833923 
	C1170.194580,878.266907 1172.375732,878.700012 1174.894531,878.260254 
	C1177.252808,878.036804 1179.242065,877.982178 1181.644409,877.810059 
	C1183.251465,877.347351 1184.511108,877.689575 1186.053223,877.225708 
	C1188.025879,877.046997 1189.650269,876.986389 1191.666016,876.809082 
	C1193.191162,876.374573 1194.369019,876.627014 1195.802124,876.234253 
	C1197.151489,876.024536 1198.210449,876.004883 1199.653320,875.876099 
	C1201.171875,875.311218 1202.387573,875.659668 1203.852295,875.239868 
	C1205.202026,875.039429 1206.242554,875.011963 1207.660156,874.875732 
	C1209.160400,874.315552 1210.360229,874.648926 1211.799194,874.235718 
	C1216.864380,873.587524 1214.449707,877.056702 1214.869629,879.425659 
	C1214.206421,880.905029 1214.599976,882.127991 1214.354736,883.615112 
	C1214.099854,885.285095 1213.940308,886.614563 1213.843994,888.342285 
	C1213.271484,889.855164 1213.568481,891.091064 1213.340454,892.617310 
	C1213.079102,894.252075 1212.925171,895.542236 1212.829834,897.219055 
	C1212.521973,898.460266 1212.461670,899.364685 1212.380249,900.610901 
	C1212.149536,902.322998 1211.991821,903.701660 1211.895020,905.493896 
	C1211.161133,906.935120 1211.621094,908.150696 1211.367920,909.610596 
	C1211.124146,911.307861 1210.964478,912.666748 1210.868896,914.432495 
	C1210.206421,915.905029 1210.599976,917.127991 1210.354736,918.615112 
	C1210.466919,923.937378 1207.725952,926.991638 1204.030151,930.020447 
	C1158.087524,967.671082 1112.259033,1005.460693 1066.416626,1043.233521 
	C1064.887939,1044.493042 1063.523071,1045.951538 1062.036377,1047.658203 
	C1060.948120,1049.647583 1061.747681,1051.486206 1061.356445,1053.582764 
	C1061.102417,1071.205688 1060.944946,1088.457886 1060.843262,1106.149902 
	C1059.975586,1114.887085 1060.634521,1123.210693 1060.510010,1131.520996 
	C1060.377686,1140.351074 1060.520142,1149.184204 1060.344971,1158.488770 
	C1060.097412,1175.970703 1059.961792,1192.979736 1059.891357,1210.447510 
	C1058.900635,1215.815674 1059.576416,1220.784302 1059.522705,1225.720581 
	C1059.391235,1237.812134 1059.512573,1249.905762 1059.373291,1262.473145 
	C1059.123413,1274.608521 1058.962891,1286.269043 1058.867676,1298.384521 
	C1058.102051,1300.226562 1058.658813,1301.765259 1058.369385,1303.584595 
	C1058.132568,1305.651489 1057.981323,1307.354736 1057.893188,1309.482178 
	C1057.001221,1311.601685 1057.722534,1313.456787 1057.341553,1315.589600 
	C1057.081055,1317.573120 1056.929199,1319.183960 1056.836182,1321.195190 
	C1056.241333,1323.082153 1056.583008,1324.664185 1056.356445,1326.577759 
	C1056.106689,1328.636963 1055.953857,1330.319580 1055.866943,1332.420776 
	C1055.103638,1334.223877 1055.656128,1335.758545 1055.382324,1337.576904 
	C1055.148193,1339.647095 1054.989136,1341.351929 1054.893066,1343.481689 
	C1054.001343,1345.601807 1054.722534,1347.456787 1054.341553,1349.589600 
	C1054.082031,1351.614258 1053.931152,1353.266235 1053.844116,1355.328613 
	C1053.165039,1357.172119 1053.627197,1358.728027 1053.356079,1360.586792 
	C1053.106812,1362.636963 1052.953857,1364.319580 1052.866943,1366.420776 
	C1052.103638,1368.223877 1052.656128,1369.758545 1052.382446,1371.576904 
	C1052.148315,1373.647095 1051.989258,1375.351929 1051.893311,1377.481689 
	C1051.001343,1379.601807 1051.722534,1381.456787 1051.341553,1383.589600 
	C1051.082031,1385.614258 1050.931152,1387.266235 1050.844238,1389.328613 
	C1050.165039,1391.172119 1050.627197,1392.728027 1050.356201,1394.586792 
	C1050.106812,1396.636963 1049.953979,1398.319580 1049.867065,1400.420776 
	C1049.103638,1402.223877 1049.656128,1403.758545 1049.382324,1405.576904 
z"
      />
      <path
        fill="#0B8E36"
        opacity="1.000000"
        stroke="none"
        d="
M1126.190186,840.129272 
	C1126.015259,839.160583 1125.985596,838.413147 1125.836548,837.309631 
	C1125.525146,836.373474 1125.527832,835.745056 1125.199829,834.883606 
	C1125.077637,833.609375 1125.032104,832.631165 1124.863770,831.304688 
	C1124.397949,830.118835 1124.619263,829.198853 1124.227539,828.045654 
	C1124.057739,826.727295 1124.020874,825.712280 1123.875488,824.329468 
	C1123.315796,822.838745 1123.648560,821.638977 1123.235474,820.200073 
	C1123.021118,818.848511 1122.998047,817.790466 1122.871094,816.346985 
	C1122.303345,814.809021 1122.678101,813.567505 1122.240967,812.067627 
	C1122.052490,810.401855 1122.011963,809.064880 1121.855957,807.341614 
	C1121.311401,805.768311 1121.701904,804.492737 1121.226562,802.947754 
	C1121.062012,800.977112 1121.016113,799.356750 1120.855347,797.345459 
	C1120.293457,795.490906 1120.669434,793.970093 1120.249023,792.165039 
	C1120.034912,790.149048 1120.002808,788.459900 1119.855713,786.362671 
	C1119.267944,784.163879 1119.682373,782.324463 1119.254150,780.179260 
	C1119.027588,777.820129 1118.988525,775.802856 1118.832764,773.366699 
	C1118.280884,771.134583 1118.695068,769.275391 1118.255615,767.095093 
	C1118.051147,764.423950 1118.010376,762.111267 1117.854980,759.376465 
	C1117.236450,756.507263 1117.700439,754.022217 1117.258545,751.201050 
	C1117.035278,748.169250 1117.004028,745.501526 1116.869873,742.397339 
	C1116.188843,738.854919 1116.723877,735.712036 1116.261475,732.216187 
	C1116.027832,728.172485 1115.989380,724.508301 1115.833618,720.395813 
	C1115.230591,715.822144 1115.714355,711.676025 1115.270996,707.140625 
	C1115.038452,700.442871 1114.985840,694.150330 1114.812988,687.399414 
	C1114.302246,668.967163 1114.600342,650.991272 1114.626709,632.534241 
	C1114.876709,627.390686 1115.037231,622.729309 1115.132080,617.615295 
	C1116.012573,614.441162 1115.269531,611.622437 1115.642334,608.453857 
	C1115.884644,606.016113 1116.028687,603.986877 1116.108398,601.525513 
	C1116.998413,599.398254 1116.277588,597.543579 1116.658447,595.410950 
	C1116.918091,593.709473 1117.069214,592.380493 1117.157349,590.654053 
	C1117.562012,589.456543 1117.509521,588.564331 1117.633301,587.368958 
	C1117.875732,586.012268 1118.034790,584.975159 1118.131226,583.547974 
	C1118.361206,582.680298 1118.516846,582.159668 1118.607910,581.332520 
	C1119.203491,569.089111 1127.262451,565.295349 1137.802368,563.596375 
	C1138.348755,563.389404 1138.533081,563.394043 1138.939453,563.233887 
	C1139.892090,563.033447 1140.622681,562.997925 1141.700195,562.839600 
	C1142.627441,562.525024 1143.256104,562.528076 1144.117432,562.199341 
	C1145.390625,562.074707 1146.367554,562.026855 1147.693726,561.859924 
	C1148.880737,561.397217 1149.801025,561.619568 1150.954590,561.227539 
	C1152.597778,561.045959 1153.937744,560.997375 1155.664551,560.832520 
	C1157.193726,560.350403 1158.393677,560.645813 1159.854492,560.238953 
	C1161.853027,560.027771 1163.544067,559.988403 1165.643799,559.832581 
	C1167.844971,559.291870 1169.678345,559.672363 1171.821777,559.253784 
	C1174.838501,559.021118 1177.514282,558.975525 1180.624268,558.811279 
	C1184.480347,558.275696 1187.920166,558.677124 1191.720093,558.254272 
	C1211.038452,558.095154 1229.983032,558.146362 1249.382080,558.131958 
	C1254.227539,559.049316 1258.683594,558.235229 1263.530518,558.656372 
	C1267.289917,558.910645 1270.617798,559.054321 1274.391113,559.132202 
	C1277.562012,560.015320 1280.385620,559.265747 1283.555786,559.657227 
	C1286.268921,559.917053 1288.575806,560.067139 1291.309326,560.154297 
	C1293.832397,560.955444 1296.036865,560.295044 1298.569336,560.657715 
	C1300.661621,560.902222 1302.361328,561.037415 1304.483765,561.108398 
	C1306.598389,561.996948 1308.448608,561.280640 1310.580444,561.643677 
	C1312.568359,561.901245 1314.181519,562.062073 1316.196167,562.164917 
	C1317.759644,562.634949 1319.003052,562.485535 1320.582275,562.618042 
	C1322.321899,562.850525 1323.700806,563.008301 1325.493408,563.105225 
	C1326.935181,563.838379 1328.150635,563.379395 1329.610718,563.632080 
	C1331.241699,563.884521 1332.534424,564.052673 1334.215576,564.166077 
	C1335.464966,564.482178 1336.377686,564.534973 1337.626953,564.646118 
	C1338.967285,564.899658 1339.977051,565.058350 1341.367188,565.156677 
	C1342.268311,565.317078 1342.794189,565.519958 1343.648071,565.591064 
	C1344.969238,565.809875 1346.010498,565.989868 1347.446777,566.119141 
	C1348.319336,566.360596 1348.839478,566.517090 1349.666504,566.607788 
	C1350.675537,566.808044 1351.414062,566.957825 1352.530762,567.076416 
	C1353.351807,567.392517 1353.872314,567.513977 1354.681885,567.623535 
	C1366.402344,568.660400 1368.626465,577.129333 1370.155029,586.656372 
	C1370.469482,587.598328 1370.473267,588.194580 1370.792236,589.012207 
	C1370.946533,590.296814 1370.999268,591.308655 1371.167725,592.684937 
	C1371.582520,593.862305 1371.400146,594.737000 1371.780396,595.827271 
	C1371.987183,597.156006 1372.018921,598.219543 1372.166992,599.666504 
	C1372.590332,600.922119 1372.367676,601.872375 1372.784180,603.069702 
	C1372.933838,604.691956 1372.979736,605.988159 1373.129395,607.661621 
	C1373.731812,609.498962 1373.319824,611.027405 1373.750488,612.834106 
	C1373.972290,614.852905 1374.011597,616.543945 1374.167236,618.643555 
	C1374.704956,620.830017 1374.334229,622.647461 1374.754272,624.764404 
	C1374.980591,627.128845 1375.005249,629.164429 1375.144775,631.622803 
	C1375.781494,634.219421 1375.240601,636.450439 1375.755859,639.020813 
	C1375.941650,642.333191 1375.986084,645.256897 1376.145020,648.613220 
	C1376.781494,652.467163 1376.296143,655.915405 1376.745361,659.718994 
	C1376.980591,664.441467 1377.005127,668.789368 1377.144653,673.591553 
	C1377.814331,681.535706 1377.243286,689.041077 1377.733398,696.972900 
	C1377.861328,709.220398 1377.823730,721.029297 1377.847656,733.286621 
	C1376.968384,740.485474 1377.748291,747.273743 1377.372681,754.493225 
	C1377.117676,758.914368 1376.951660,762.880798 1376.847290,767.291565 
	C1375.990601,770.496216 1376.740601,773.346985 1376.342896,776.551453 
	C1376.082275,779.226929 1375.931763,781.492371 1375.838257,784.175964 
	C1375.243896,786.078308 1375.579590,787.656860 1375.369873,789.569946 
	C1375.115967,791.603882 1374.948364,793.259399 1374.843994,795.327026 
	C1374.274780,796.851013 1374.565063,798.082458 1374.354980,799.608398 
	C1374.117798,801.008850 1373.976196,802.062378 1373.895020,803.511963 
	C1373.682983,804.289185 1373.526001,804.713013 1373.494385,805.524658 
	C1369.663940,825.701904 1369.683716,825.760925 1350.254150,832.279846 
	C1343.011719,834.709839 1335.666748,836.839417 1328.342651,839.018982 
	C1322.167603,840.856628 1320.791626,843.070740 1322.440796,849.245483 
	C1328.787476,873.009216 1335.161621,896.765503 1341.555298,920.516541 
	C1342.207764,922.939880 1342.601562,924.983459 1340.969604,927.483643 
	C1338.465454,931.319824 1339.983276,934.455505 1344.854614,936.960144 
	C1363.330322,946.459839 1381.817627,955.936951 1400.303589,965.416748 
	C1422.930298,977.020081 1445.526367,988.684143 1468.220581,1000.153748 
	C1472.103271,1002.115967 1473.876221,1005.098816 1475.477295,1008.933411 
	C1487.367554,1037.410278 1499.516602,1065.779053 1511.535889,1094.202148 
	C1515.749756,1104.166870 1519.828491,1114.188843 1523.965332,1124.565430 
	C1523.063965,1126.678589 1523.509399,1128.542969 1523.506470,1130.339722 
	C1523.447144,1166.592896 1523.543701,1202.846069 1523.270386,1239.561890 
	C1523.066772,1252.365479 1523.032227,1264.706177 1522.985840,1277.514404 
	C1522.051758,1279.707397 1522.511108,1281.572266 1522.507202,1283.365723 
	C1522.448242,1309.953613 1522.535522,1336.541504 1522.300781,1363.597656 
	C1511.223755,1396.951294 1500.291260,1429.836426 1489.361206,1462.722534 
	C1489.048706,1463.663086 1488.763550,1464.612793 1488.268921,1465.871216 
	C1481.015259,1466.833618 1473.944458,1466.350464 1466.421509,1466.295532 
	C1463.609253,1466.097168 1461.256104,1466.047974 1458.461426,1465.991333 
	C1450.648315,1464.862671 1443.226318,1465.822998 1435.394043,1465.303101 
	C1432.292114,1465.094238 1429.632568,1465.027466 1426.530151,1464.950195 
	C1418.691650,1463.924927 1411.253906,1464.792236 1403.406494,1464.279785 
	C1400.612793,1464.079102 1398.256226,1464.039185 1395.457642,1463.994385 
	C1387.647461,1462.853638 1380.227661,1463.827271 1372.397705,1463.307007 
	C1369.598267,1463.112061 1367.242310,1463.056152 1364.443848,1462.999512 
	C1356.305908,1461.832886 1348.557861,1462.844238 1340.406616,1462.279785 
	C1337.622314,1462.072388 1335.275146,1462.025635 1332.488159,1461.973999 
	C1324.667603,1460.883545 1317.239502,1461.811401 1309.398071,1461.307007 
	C1303.972290,1461.053955 1298.990356,1460.939941 1293.551270,1460.891113 
	C1288.060669,1459.943115 1282.966797,1460.760620 1277.473999,1460.343750 
	C1272.078247,1460.083984 1267.118774,1459.934937 1261.712036,1459.847656 
	C1256.513916,1458.945435 1251.706909,1459.768799 1246.493652,1459.372314 
	C1241.037842,1459.131104 1236.023560,1458.978516 1230.551758,1458.891113 
	C1225.060669,1457.943115 1219.966797,1458.760620 1214.473999,1458.343750 
	C1209.078247,1458.083984 1204.118774,1457.934937 1198.712036,1457.847656 
	C1193.513916,1456.945435 1188.706909,1457.768799 1183.493652,1457.372314 
	C1178.037842,1457.131104 1173.023560,1456.978516 1167.551758,1456.891113 
	C1162.060669,1455.943115 1156.966797,1456.760620 1151.473999,1456.343628 
	C1146.121094,1456.084229 1141.204468,1455.935669 1135.849365,1455.843140 
	C1130.606567,1454.974487 1125.750244,1455.749512 1120.484131,1455.351807 
	C1115.050659,1455.098633 1110.059937,1454.950439 1104.615845,1454.867676 
	C1101.791992,1453.979614 1099.312744,1454.729004 1096.491211,1454.423340 
	C1088.823608,1454.124023 1081.562622,1453.870972 1073.876953,1453.750488 
	C1071.626709,1453.194580 1069.717773,1453.607666 1067.454590,1453.383789 
	C1065.974121,1453.221558 1064.890381,1453.135986 1063.403809,1453.127563 
	C1061.988647,1453.939087 1060.902344,1454.077515 1059.370361,1453.387939 
	C1057.794678,1452.971924 1056.922241,1452.502563 1057.176758,1450.725098 
	C1057.757812,1448.919067 1057.417480,1447.336670 1057.643555,1445.422729 
	C1057.893311,1443.363403 1058.046387,1441.680786 1058.133301,1439.579834 
	C1058.897461,1437.773926 1058.341309,1436.235107 1058.630859,1434.415527 
	C1058.867798,1432.348389 1059.019043,1430.645142 1059.107178,1428.517700 
	C1059.998535,1426.398193 1059.277466,1424.543213 1059.658569,1422.410400 
	C1059.918091,1420.385986 1060.069092,1418.734253 1060.156006,1416.672241 
	C1060.834229,1414.828491 1060.373291,1413.272583 1060.643799,1411.413574 
	C1060.893311,1409.363525 1061.046265,1407.681030 1061.133179,1405.579956 
	C1061.895630,1403.776489 1061.344116,1402.241577 1061.617676,1400.422852 
	C1061.851929,1398.352661 1062.011108,1396.647949 1062.107178,1394.518311 
	C1062.998535,1392.398193 1062.277466,1390.543213 1062.658569,1388.410400 
	C1062.918091,1386.385986 1063.069092,1384.734253 1063.156006,1382.672241 
	C1063.834229,1380.828491 1063.373291,1379.272583 1063.643799,1377.413574 
	C1063.893311,1375.363525 1064.046265,1373.681030 1064.133179,1371.579956 
	C1064.895630,1369.776489 1064.344116,1368.241577 1064.617676,1366.422852 
	C1064.868530,1364.115479 1065.044189,1362.173340 1065.162231,1359.818604 
	C1065.760254,1357.915283 1065.413940,1356.328003 1065.658447,1354.412476 
	C1065.917847,1352.386108 1066.068726,1350.734253 1066.155762,1348.672363 
	C1066.832886,1346.831299 1066.375854,1345.279175 1066.630615,1343.421021 
	C1066.877319,1341.367554 1067.038208,1339.683594 1067.133179,1337.580444 
	C1067.895630,1335.776489 1067.344116,1334.241577 1067.617676,1332.422852 
	C1067.868408,1330.115479 1068.044067,1328.173340 1068.162354,1325.818604 
	C1068.757812,1323.919067 1068.417480,1322.336670 1068.643555,1320.422729 
	C1068.900024,1318.392212 1069.059692,1316.738525 1069.155762,1314.673340 
	C1069.832886,1312.831299 1069.375854,1311.279175 1069.630615,1309.421021 
	C1069.868408,1307.348511 1070.020508,1305.645264 1070.108276,1303.517822 
	C1070.997070,1301.402100 1070.280640,1299.552368 1070.643555,1297.420898 
	C1070.884888,1280.034668 1071.029541,1263.023315 1071.108887,1245.552979 
	C1072.099243,1240.183716 1071.423096,1235.214111 1071.477417,1230.276855 
	C1071.610474,1218.182983 1071.483521,1206.087036 1071.640259,1193.519287 
	C1071.884888,1176.034912 1072.029541,1159.023438 1072.108887,1141.552979 
	C1073.099243,1136.183716 1072.423096,1131.214111 1072.477539,1126.276855 
	C1072.610596,1114.182983 1072.483521,1102.087036 1072.640137,1089.519287 
	C1072.891846,1078.744995 1073.170776,1068.442749 1073.120117,1058.142212 
	C1073.104126,1054.887329 1073.984985,1052.752441 1076.599609,1050.607300 
	C1123.391724,1012.216980 1170.077271,973.696960 1216.814819,935.239990 
	C1219.199097,933.278198 1221.455078,931.398254 1221.132690,927.544373 
	C1221.792969,926.095581 1221.400391,924.872437 1221.645386,923.385010 
	C1221.900269,921.715332 1222.059814,920.386230 1222.156006,918.658936 
	C1222.727539,917.145630 1222.432007,915.909546 1222.659546,914.382812 
	C1222.921021,912.748291 1223.074829,911.458496 1223.170044,909.782227 
	C1223.477417,908.540649 1223.538574,907.635925 1223.619751,906.389038 
	C1223.850708,904.677063 1224.008301,903.298523 1224.105103,901.506531 
	C1224.838501,900.065063 1224.378906,898.849365 1224.632324,897.389282 
	C1224.876099,895.692261 1225.035767,894.333801 1225.131226,892.568359 
	C1225.792969,891.095581 1225.400391,889.872437 1225.645386,888.385010 
	C1225.900269,886.715332 1226.059814,885.386230 1226.156006,883.658936 
	C1226.727539,882.145630 1226.432007,880.909546 1226.659424,879.382812 
	C1226.920898,877.748291 1227.074829,876.458496 1227.169922,874.782227 
	C1227.477417,873.540649 1227.538574,872.635925 1227.619751,871.389038 
	C1228.811768,862.635742 1227.249512,860.653015 1219.369385,861.136963 
	C1218.119263,861.602783 1217.198975,861.380432 1216.045410,861.772461 
	C1214.723999,861.943481 1213.706055,861.981506 1212.322510,862.139282 
	C1211.089722,862.607056 1210.130615,862.366394 1208.930664,862.783936 
	C1207.300781,862.950745 1205.998047,863.013062 1204.319580,863.191284 
	C1203.097412,863.573914 1202.192627,863.388428 1201.043213,863.773804 
	C1199.402100,863.954102 1198.062134,864.002625 1196.335205,864.167419 
	C1194.817505,864.643372 1193.633179,864.366577 1192.198242,864.765259 
	C1190.520996,864.987061 1189.135010,865.018494 1187.348389,865.166870 
	C1185.494385,865.680908 1183.995605,865.347717 1182.218750,865.757996 
	C1180.195679,865.987427 1178.484863,866.019104 1176.360840,866.167297 
	C1174.134399,866.718933 1172.275391,866.305115 1170.095215,866.744385 
	C1166.438110,866.948914 1163.139160,866.989563 1159.397461,867.144897 
	C1155.287598,867.738342 1151.605835,867.390198 1147.484741,867.344177 
	C1145.092896,867.080017 1143.147705,866.926941 1140.788818,866.824707 
	C1140.182495,866.796936 1139.990112,866.718384 1139.486328,866.629272 
	C1134.567017,865.833984 1132.185303,862.929321 1130.833130,858.584167 
	C1129.204712,853.351196 1127.909180,848.060913 1126.736572,842.300049 
	C1126.550659,841.382629 1126.525513,840.853394 1126.190186,840.129272 
z"
      />
      <path
        fill="#0C8E36"
        opacity="1.000000"
        stroke="none"
        d="
M1219.541748,1472.576172 
	C1221.005859,1472.703369 1222.096924,1472.787598 1223.592529,1472.784912 
	C1225.030273,1472.006592 1226.119263,1471.903687 1227.632080,1472.610596 
	C1230.345703,1472.946045 1232.691284,1473.059448 1235.472046,1473.108032 
	C1238.929077,1474.051636 1242.048584,1473.242188 1245.525391,1473.615112 
	C1249.536133,1473.865967 1253.130249,1474.039673 1257.158447,1474.157471 
	C1260.729126,1474.986694 1263.939819,1474.274902 1267.529297,1474.641602 
	C1271.284424,1474.892334 1274.615479,1475.044800 1278.392578,1475.131592 
	C1281.886230,1476.025024 1285.022095,1475.255737 1288.523193,1475.614990 
	C1292.296509,1475.852417 1295.651001,1476.012695 1299.456421,1476.108154 
	C1303.270264,1477.107422 1306.730469,1476.200439 1310.545532,1476.656738 
	C1312.357300,1476.844116 1313.752563,1476.921753 1315.568848,1477.002197 
	C1321.020752,1478.106079 1326.124268,1477.203491 1331.608887,1477.701416 
	C1333.715942,1477.911621 1335.396240,1477.976440 1337.497070,1478.047119 
	C1342.644409,1479.102783 1347.439941,1478.193115 1352.618408,1478.693115 
	C1354.741455,1478.888062 1356.436768,1478.944458 1358.556519,1479.008301 
	C1364.017578,1480.095703 1369.124878,1479.202393 1374.609131,1479.719971 
	C1376.411987,1479.919800 1377.793091,1479.959351 1379.589355,1479.997314 
	C1385.030762,1481.117065 1390.132324,1480.197632 1395.612305,1480.704956 
	C1397.726074,1480.909546 1399.414185,1480.965820 1401.524902,1481.029419 
	C1406.997314,1482.075073 1412.112671,1481.208252 1417.605469,1481.729492 
	C1419.403687,1481.931274 1420.782471,1481.965332 1422.575684,1482.002197 
	C1428.020752,1483.106079 1433.124268,1482.203491 1438.608887,1482.701416 
	C1443.200928,1483.452026 1447.581299,1482.323364 1451.975952,1484.497925 
	C1442.117188,1493.929810 1431.701904,1502.353516 1421.269287,1510.739380 
	C1400.192505,1527.681030 1377.867432,1542.889771 1355.019897,1557.296021 
	C1344.362671,1564.015747 1333.092773,1569.765259 1322.086426,1575.929321 
	C1300.477783,1588.031372 1277.887329,1598.123047 1254.961060,1607.330688 
	C1232.797974,1616.231567 1210.087036,1623.690796 1186.995605,1629.972778 
	C1162.622192,1636.603638 1137.940186,1641.686157 1113.008057,1645.540771 
	C1100.387817,1647.492065 1087.729370,1649.247559 1074.947998,1650.092651 
	C1065.950195,1650.687622 1056.997437,1651.980591 1047.492920,1652.060913 
	C1038.952637,1653.007080 1030.842651,1652.175171 1022.329163,1652.733643 
	C1017.594177,1652.946167 1013.283936,1652.963135 1008.513123,1652.971680 
	C1000.003113,1651.878540 991.910278,1652.810669 983.402771,1652.291626 
	C932.397705,1650.487671 883.068359,1641.494873 834.625183,1626.999268 
	C854.775940,1626.999268 874.926636,1627.001709 895.077393,1626.998047 
	C903.783447,1626.996460 906.271484,1624.317383 904.084961,1616.017090 
	C901.023987,1604.397583 897.452576,1592.908936 893.946472,1581.411133 
	C888.204529,1562.581543 882.269531,1543.810791 876.545654,1524.975830 
	C870.675049,1505.658081 865.027527,1486.272461 859.157959,1466.954346 
	C853.388672,1447.966431 847.462463,1429.026123 841.607239,1410.064331 
	C840.850403,1407.613403 841.221069,1404.797729 839.123901,1402.378906 
	C840.162354,1397.316650 839.157532,1392.535522 839.726074,1387.392334 
	C839.927124,1385.594482 839.963196,1384.213135 840.000610,1382.416748 
	C841.137329,1376.639648 840.189209,1371.205688 840.720520,1365.393188 
	C840.934509,1363.285889 840.987793,1361.602661 841.044067,1359.498169 
	C842.059387,1354.019653 841.223022,1348.900635 841.701294,1343.392456 
	C841.897827,1341.264648 841.949036,1339.564941 842.005188,1337.439697 
	C843.124878,1331.647949 842.194763,1326.212280 842.725952,1320.398193 
	C842.927124,1318.594482 842.963196,1317.213135 843.000610,1315.416748 
	C844.137329,1309.639648 843.189209,1304.205688 843.720520,1298.393188 
	C843.934509,1296.285889 843.987732,1294.602661 844.044067,1292.498169 
	C845.059387,1287.019653 844.223022,1281.900635 844.701294,1276.392456 
	C844.897888,1274.264648 844.949036,1272.564941 845.005188,1270.439697 
	C846.124878,1264.647949 845.194763,1259.212280 845.725952,1253.398193 
	C845.927124,1251.594482 845.963257,1250.213135 846.000610,1248.416748 
	C847.137329,1242.639648 846.189209,1237.205688 846.720520,1231.393188 
	C846.934509,1229.285889 846.987793,1227.602661 847.044067,1225.498169 
	C848.059387,1220.019653 847.223022,1214.900635 847.701294,1209.392456 
	C847.897888,1207.264648 847.949097,1205.564941 848.005188,1203.439697 
	C849.124878,1197.647949 848.194763,1192.212280 848.725952,1186.398193 
	C848.927124,1184.594482 848.963196,1183.213135 849.000610,1181.416748 
	C850.137329,1175.639648 849.189209,1170.205688 849.720520,1164.393188 
	C849.928040,1162.277588 849.974854,1160.585815 850.026123,1158.470947 
	C851.076233,1152.999634 850.218384,1147.886230 850.692871,1142.384033 
	C850.887878,1140.258667 850.944397,1138.563110 851.008301,1136.443237 
	C852.116577,1130.649536 851.198486,1125.212280 851.729370,1119.396729 
	C851.931274,1117.594116 851.965332,1116.212891 852.000671,1114.416748 
	C853.137329,1108.639648 852.189209,1103.205688 852.720520,1097.393188 
	C852.652344,1091.073242 854.574646,1085.057739 851.541626,1079.112549 
	C849.619873,1077.845825 848.675842,1076.367676 848.389404,1074.159180 
	C848.719849,1072.246826 846.956116,1071.584473 846.500488,1070.063232 
	C844.619873,1068.845825 843.675842,1067.367676 843.389404,1065.159180 
	C843.719849,1063.246826 841.956116,1062.584473 841.500488,1061.063232 
	C839.619873,1059.845825 838.675842,1058.367676 838.389404,1056.159180 
	C838.719849,1054.246826 836.956116,1053.584473 836.500488,1052.063232 
	C834.619873,1050.845825 833.675842,1049.367676 833.389404,1047.159180 
	C833.719849,1045.246826 831.956116,1044.584473 831.500488,1043.063232 
	C829.619873,1041.845825 828.675842,1040.367676 828.389404,1038.159180 
	C828.719849,1036.246826 826.956116,1035.584473 826.500488,1034.063232 
	C824.619873,1032.845825 823.675842,1031.367676 823.389404,1029.159180 
	C823.719849,1027.246826 821.956116,1026.584473 821.500488,1025.063232 
	C819.619934,1023.845703 818.675720,1022.367554 818.389282,1020.158936 
	C818.720581,1018.246826 816.955322,1017.585388 816.501221,1016.063843 
	C814.620117,1014.846558 813.675720,1013.368225 813.389282,1011.159119 
	C813.720581,1009.246826 811.955322,1008.585388 811.501221,1007.063843 
	C809.620117,1005.846558 808.675720,1004.368225 808.389282,1002.159119 
	C808.720581,1000.246826 806.955322,999.585388 806.501221,998.063843 
	C804.308044,996.401672 802.947144,994.416443 801.211304,992.326416 
	C789.486084,986.744446 778.002441,981.346313 766.451355,976.096497 
	C747.886841,967.659119 729.268311,959.340759 710.690186,950.933289 
	C691.386047,942.197266 672.356140,932.851013 652.701294,924.895630 
	C648.990845,923.393860 647.639343,920.167847 647.094788,916.617554 
	C645.076477,903.461060 643.172729,890.289429 640.099854,877.319214 
	C639.199280,873.517883 640.570435,872.613281 644.945374,873.304626 
	C662.553467,876.087158 680.223511,878.347046 698.518066,879.013794 
	C708.704590,880.120239 718.463867,879.276611 728.608765,879.232422 
	C740.336792,878.622620 746.507751,872.908875 749.910583,859.572266 
	C753.521729,845.418823 756.330383,831.072144 758.004333,816.593689 
	C759.309631,805.303101 760.273254,793.928711 761.336609,782.608154 
	C762.421265,771.061035 762.134216,759.411316 764.043213,747.511475 
	C765.111267,742.354675 764.187561,737.560974 764.701477,732.388184 
	C764.897461,730.258301 764.948059,728.553589 764.997192,726.421997 
	C766.156372,717.967896 765.178528,709.891235 765.692627,701.399902 
	C766.397095,680.290039 766.202759,659.624207 765.929565,638.494629 
	C765.024597,631.299316 765.813538,624.533813 765.231934,617.388550 
	C763.777161,603.378601 763.054810,589.701233 761.176270,576.184692 
	C759.044556,560.846619 755.122009,556.353577 735.532593,551.731140 
	C725.973450,549.475586 716.128723,548.674500 706.320679,547.652466 
	C699.169617,546.907288 691.889343,547.925964 684.428345,546.005615 
	C683.124939,545.324646 682.098572,545.489014 681.117310,545.490479 
	C657.364258,545.526001 633.611084,545.396423 609.434814,545.779907 
	C607.299194,546.010620 605.586853,546.011963 603.449341,546.061157 
	C597.959351,546.989136 592.846497,546.183472 587.375916,546.767334 
	C570.927612,547.857910 554.903076,549.152649 538.688660,550.277771 
	C664.646362,420.292480 817.742737,351.066742 999.514526,344.868286 
	C1009.674072,344.182037 1019.382263,344.647156 1029.553955,344.680420 
	C1032.691040,344.886749 1035.359985,344.962555 1038.473633,345.045654 
	C1043.643921,346.102722 1048.439087,345.191315 1053.613525,345.704803 
	C1082.486328,348.122986 1110.746582,351.505646 1138.848511,356.811707 
	C1204.046021,369.121918 1265.538452,391.547150 1323.956421,422.690247 
	C1347.349854,435.161438 1369.766724,449.267731 1391.475342,464.488739 
	C1392.691650,465.341614 1394.216064,466.043121 1394.946899,467.219147 
	C1395.672852,468.386902 1394.096924,467.678192 1393.345703,468.060760 
	C1387.959595,468.989288 1382.846924,468.183594 1377.376587,468.767273 
	C1375.579224,469.003479 1374.172852,469.017059 1372.360352,469.145447 
	C1368.822876,469.785339 1365.659302,469.278564 1362.128662,469.731812 
	C1358.438232,469.949799 1355.139160,469.990326 1351.397217,470.145538 
	C1347.847534,470.779266 1344.710327,470.291290 1341.216797,470.738739 
	C1337.504395,470.972626 1334.170776,471.011261 1330.392212,471.167145 
	C1326.856201,471.747253 1323.740845,471.312012 1320.275269,471.746887 
	C1316.549438,471.994019 1313.191772,472.031616 1309.387573,472.188599 
	C1306.104248,472.747681 1303.235474,472.257233 1299.993652,472.749115 
	C1296.343506,472.941254 1293.094727,472.984589 1289.404053,473.130707 
	C1285.795776,473.839996 1282.583130,473.216095 1279.000122,473.746094 
	C1275.339111,473.942535 1272.086426,473.986725 1268.393921,474.145569 
	C1264.822876,474.785339 1261.659302,474.278564 1258.128662,474.731812 
	C1254.435791,474.956207 1251.134155,475.003143 1247.389893,475.167236 
	C1243.840210,475.750854 1240.707886,475.304504 1237.216309,475.738861 
	C1233.504395,475.972656 1230.170776,476.011261 1226.392212,476.167175 
	C1222.856201,476.747253 1219.740845,476.312012 1216.275269,476.746887 
	C1212.549438,476.994019 1209.191772,477.031616 1205.387573,477.188599 
	C1202.104248,477.747681 1199.235474,477.257233 1195.993652,477.749084 
	C1192.343506,477.941254 1189.094727,477.984558 1185.404053,478.130676 
	C1181.831299,478.816772 1178.661987,478.263916 1175.129272,478.731689 
	C1171.438232,478.949799 1168.139160,478.990326 1164.397217,479.145538 
	C1160.822876,479.785339 1157.659302,479.278564 1154.128662,479.731812 
	C1150.435791,479.956207 1147.134155,480.003143 1143.389893,480.167236 
	C1139.840210,480.750854 1136.707886,480.304504 1133.216309,480.738831 
	C1129.502319,480.979126 1126.166504,481.024261 1122.385986,481.188721 
	C1118.849731,481.719635 1115.738525,481.324860 1112.274658,481.746948 
	C1108.888062,481.980164 1105.869019,482.003937 1102.406006,482.130615 
	C1098.795776,482.839996 1095.583130,482.216095 1092.000122,482.746094 
	C1088.343262,482.941528 1085.094604,482.984711 1081.404053,483.130737 
	C1077.831299,483.816772 1074.661987,483.263916 1071.129272,483.731659 
	C1067.438232,483.949768 1064.139160,483.990295 1060.397217,484.145508 
	C1056.847534,484.779266 1053.710327,484.291290 1050.216797,484.738770 
	C1046.504395,484.972656 1043.170776,485.011292 1039.392212,485.167175 
	C1035.856201,485.747253 1032.740845,485.312012 1029.275269,485.746887 
	C1025.549438,485.993988 1022.191589,486.031586 1018.387390,486.188599 
	C1014.849731,486.719604 1011.738525,486.324890 1008.274780,486.746948 
	C1004.888000,486.980225 1001.868835,487.003998 998.405518,487.130676 
	C994.795471,487.839844 991.583130,487.216217 988.000366,487.746033 
	C984.339417,487.942535 981.086609,487.986786 977.393921,488.145630 
	C973.822693,488.785339 970.659180,488.278564 967.128662,488.731812 
	C963.438171,488.949799 960.138977,488.990326 956.396973,489.145538 
	C952.847473,489.779266 949.710388,489.291290 946.216919,489.738739 
	C942.504639,489.972595 939.171265,490.011200 935.393005,490.167053 
	C931.856812,490.747375 928.741028,490.311951 925.275269,490.746887 
	C921.549438,490.994019 918.191589,491.031616 914.387451,491.188599 
	C911.798279,491.707642 909.623108,491.311523 907.106323,491.739807 
	C904.335388,491.893188 902.976318,493.325653 902.003906,495.657227 
	C901.241333,497.044128 901.493286,498.245758 901.494263,499.388184 
	C901.514526,523.352905 901.416870,547.317688 901.734497,571.722046 
	C901.965027,605.480225 901.995972,638.798706 902.130249,672.578186 
	C902.793030,680.003296 902.442627,686.979187 902.465271,693.948669 
	C902.551025,720.366699 902.406738,746.785034 902.749512,773.647888 
	C902.987122,807.440002 903.017761,840.787415 903.166382,874.593506 
	C903.738403,893.036743 903.382751,911.024292 903.476990,929.010254 
	C903.556396,944.168945 903.395508,959.328186 903.724854,974.947449 
	C903.954773,1008.985779 904.011047,1042.563599 904.187683,1076.600098 
	C904.709473,1102.315674 904.373657,1127.574219 904.484070,1152.831787 
	C904.518250,1160.642578 904.416626,1168.453735 904.735168,1176.713135 
	C904.966003,1210.483887 904.998047,1243.805908 905.145142,1277.587036 
	C905.764954,1289.998169 905.417053,1301.955811 905.468872,1313.910645 
	C905.561768,1335.341431 905.406799,1356.772583 905.749512,1378.648193 
	C905.971924,1404.456177 905.978333,1429.819336 906.012878,1455.182617 
	C906.017700,1458.713013 907.562805,1461.198486 911.534790,1462.074097 
	C916.265503,1463.073730 920.694458,1462.226440 925.513733,1462.627686 
	C930.962463,1462.868286 935.977173,1463.020752 941.449585,1463.108276 
	C946.939819,1464.057373 952.032898,1463.239014 957.524902,1463.656006 
	C962.921448,1463.915405 967.881897,1464.064331 973.289551,1464.151733 
	C978.487183,1465.055054 983.293579,1464.230957 988.506104,1464.627441 
	C993.962463,1464.868286 998.977051,1465.020752 1004.449524,1465.108276 
	C1009.939819,1466.057373 1015.032898,1465.239014 1020.524902,1465.656128 
	C1025.878784,1465.915283 1030.796509,1466.063843 1036.152954,1466.156494 
	C1041.392822,1467.024536 1046.245728,1466.251953 1051.509766,1466.640869 
	C1056.946167,1466.892212 1061.938843,1467.044434 1067.385010,1467.131348 
	C1072.550537,1468.085938 1077.324951,1467.217773 1082.500977,1467.614258 
	C1088.198853,1467.865601 1093.455933,1468.038940 1099.152344,1468.156494 
	C1104.392822,1469.024536 1109.245728,1468.251953 1114.509766,1468.640869 
	C1119.946167,1468.892212 1124.939087,1469.044556 1130.385254,1469.131348 
	C1135.215088,1470.041626 1139.654297,1469.246948 1144.494141,1469.600586 
	C1150.285522,1469.836182 1155.638062,1470.004761 1161.448975,1470.108276 
	C1164.245483,1471.040771 1166.702148,1470.276001 1169.495239,1470.556519 
	C1177.164673,1470.851929 1184.429443,1471.116943 1192.119385,1471.251587 
	C1194.043457,1471.715088 1195.620483,1471.446167 1197.548828,1471.602051 
	C1203.236206,1471.848877 1208.539551,1472.031128 1214.291260,1472.152588 
	C1216.157471,1472.825439 1217.692139,1472.387939 1219.541748,1472.576172 
z"
      />
      <path
        fill="#0B8E36"
        opacity="1.000000"
        stroke="none"
        d="
M468.420959,1614.765381 
	C452.300873,1615.000366 436.623352,1615.017578 420.484192,1615.111572 
	C403.337891,1615.858398 386.646362,1615.312256 369.470337,1615.418579 
	C366.018982,1609.070435 366.459198,1602.146606 365.378784,1595.509644 
	C364.027008,1587.205811 362.995941,1578.850098 361.797943,1570.520752 
	C360.628876,1562.392578 359.441254,1554.267212 358.229675,1546.145264 
	C357.034668,1538.134277 355.754517,1530.135742 354.594574,1522.119873 
	C353.443207,1514.163452 352.466034,1506.181396 351.282074,1498.229980 
	C350.067108,1490.070190 348.619415,1481.944946 347.411774,1473.784058 
	C346.228027,1465.784790 345.212769,1457.760254 344.133698,1449.745483 
	C343.055939,1441.740967 342.035583,1433.728271 340.907654,1425.730835 
	C339.736877,1417.429688 338.522888,1409.133911 337.225128,1400.851685 
	C335.949066,1392.708130 334.199951,1384.622925 333.296722,1376.441650 
	C332.463257,1368.891846 331.295135,1361.408569 330.210510,1353.901855 
	C328.985138,1345.420898 327.936066,1336.927734 326.335571,1328.490845 
	C324.831665,1320.562866 324.261627,1312.461426 323.151306,1304.454224 
	C322.019318,1296.291138 321.024445,1288.092163 319.440399,1280.012451 
	C317.015656,1267.644775 317.056091,1255.426514 320.368744,1243.258057 
	C323.411316,1232.082031 324.726929,1220.568115 327.104218,1209.260742 
	C330.209900,1194.488647 333.169769,1179.684937 336.064087,1164.869751 
	C338.189514,1153.990479 340.012939,1143.052124 342.143341,1132.173950 
	C345.039307,1117.386475 348.153625,1102.641724 351.071564,1087.858521 
	C353.190308,1077.124512 355.109131,1066.351318 357.177246,1055.607178 
	C359.996094,1040.962524 362.795715,1026.313232 365.832214,1011.713379 
	C366.165863,1010.109070 366.484711,1008.429626 366.471924,1006.924011 
	C366.376282,995.657654 376.157104,995.203491 382.985016,992.203064 
	C409.339600,980.621948 435.903076,969.515564 462.406158,958.273376 
	C479.943604,950.834229 497.514191,943.473328 515.061035,936.056213 
	C517.776306,934.908447 520.333435,934.962891 523.181152,935.942261 
	C538.829651,941.323486 554.566101,946.448975 570.211121,951.840149 
	C573.841858,953.091248 577.228394,953.104126 580.844849,952.042603 
	C599.996460,946.421204 619.166870,940.863403 638.347595,935.341919 
	C640.424622,934.744080 642.442688,934.921387 644.580688,935.902283 
	C675.125122,949.916016 705.703003,963.857178 736.302490,977.750366 
	C752.157898,984.949219 768.032776,992.108459 783.989563,999.078064 
	C787.483521,1000.604126 787.743469,1001.751465 785.433167,1004.790344 
	C759.322815,1039.136108 733.370422,1073.601929 707.296997,1107.975830 
	C704.499390,1111.664062 703.427124,1115.263672 704.529480,1119.954834 
	C705.814087,1125.421387 705.122375,1131.155396 705.675476,1136.783569 
	C706.889954,1149.140869 707.161987,1161.587402 708.028625,1173.982910 
	C709.181763,1190.475830 710.621887,1206.948853 711.772827,1223.441895 
	C712.649231,1236.001221 713.150085,1248.586792 714.029480,1261.145874 
	C715.172852,1277.474731 716.574097,1293.785278 717.772034,1310.110474 
	C718.595886,1321.338379 719.235046,1332.579834 720.006226,1343.811646 
	C721.252502,1361.962280 722.527710,1380.110962 723.817200,1398.258423 
	C724.169250,1403.213867 724.794373,1408.283936 724.582153,1413.117554 
	C724.073059,1424.707031 728.683411,1434.591919 732.906372,1444.773071 
	C749.003845,1483.582153 764.978333,1522.442261 781.052856,1561.260742 
	C787.959351,1577.939453 794.998047,1594.563354 802.103882,1611.564453 
	C802.266418,1612.115356 802.301819,1612.313843 802.220215,1612.791016 
	C801.929626,1613.089722 801.756042,1613.109741 801.323486,1613.169922 
	C799.265259,1613.722168 797.423645,1613.469849 795.603516,1613.472046 
	C750.673279,1613.525513 705.743042,1613.408325 660.361328,1613.739990 
	C643.930908,1613.973633 627.952087,1614.008423 611.510864,1614.101562 
	C609.262695,1614.767578 607.417053,1614.467163 605.601929,1614.469604 
	C560.022461,1614.530396 514.442932,1614.399902 468.420959,1614.765381 
z"
      />
      <path
        fill="#0B8E36"
        opacity="1.000000"
        stroke="none"
        d="
M688.616028,559.696777 
	C705.740173,561.446289 722.549561,562.006409 738.828125,566.852051 
	C744.309204,568.483521 746.961548,571.623047 748.021057,576.924133 
	C750.384583,588.748779 751.833984,600.651489 752.049133,612.723083 
	C752.146118,618.167114 753.325928,623.567200 753.060913,629.509399 
	C753.941284,636.571167 753.417664,643.200684 753.452393,649.814941 
	C753.528198,664.244202 753.538879,678.674438 753.286011,693.572510 
	C753.073303,697.034424 753.017639,700.028015 752.954346,703.469482 
	C751.860596,710.309570 752.831421,716.755432 752.295166,723.602234 
	C751.097107,741.709229 750.427429,759.412598 748.906799,777.042542 
	C746.741821,802.141846 744.843689,827.309448 738.935974,851.917969 
	C738.250671,854.772705 737.182678,857.554077 736.086792,860.287170 
	C734.680847,863.793640 732.055908,865.882263 728.172913,865.846558 
	C725.025696,865.817688 722.136353,867.618652 718.504456,866.960449 
	C712.677612,865.936768 707.228821,866.785095 701.392700,866.274170 
	C685.739075,865.945007 670.717102,863.444397 655.624512,861.835449 
	C650.833191,861.324646 646.075745,860.249023 641.210571,859.906555 
	C637.628662,859.654358 636.512878,856.462280 636.157166,853.671570 
	C634.689453,842.156555 632.540466,830.774353 630.188904,819.419617 
	C628.831543,812.865295 627.461182,810.877930 621.256653,811.073181 
	C611.977173,811.365051 602.784546,810.182800 593.608643,809.653809 
	C584.964111,809.155457 576.237976,808.869385 567.584656,808.308289 
	C555.420593,807.519714 543.198547,806.264648 530.953979,806.983215 
	C527.655396,807.176758 526.498352,809.807617 526.102112,812.362854 
	C525.167175,818.391418 524.572754,824.479675 524.046143,830.561523 
	C523.832031,833.034302 523.640930,834.007324 520.556030,833.149414 
	C515.495422,831.742004 510.882935,829.369446 506.078827,827.437500 
	C501.696930,825.675354 499.134247,822.233582 498.117065,817.452026 
	C496.130646,808.114441 495.029327,798.694031 494.007599,789.207825 
	C493.278107,782.435120 493.374603,775.701965 492.933838,768.494507 
	C492.024719,761.623535 492.807678,755.180359 492.247955,748.353516 
	C492.013062,744.272644 491.988617,740.600403 491.887695,736.475525 
	C491.159546,722.327026 491.659943,708.623718 491.667603,694.449585 
	C491.859192,689.964417 491.930176,685.954102 492.009064,681.481934 
	C493.130676,673.650574 492.177582,666.230225 492.729858,658.409607 
	C493.265533,647.264404 493.056610,636.493835 494.136078,625.854004 
	C495.722046,610.221619 496.816376,594.468506 500.547302,579.144592 
	C501.620789,574.735474 503.615784,571.026062 509.428467,569.685852 
	C520.414734,567.152954 531.504089,565.544373 542.635376,564.317444 
	C562.046692,562.177795 581.539978,560.869629 601.512085,559.933716 
	C609.042236,559.034119 616.147461,559.806396 623.642761,559.247803 
	C628.722961,559.007935 633.390747,558.978271 638.516602,558.868408 
	C645.010681,558.190674 651.060364,558.642883 657.562866,558.680725 
	C662.346802,558.886536 666.670837,558.961853 671.453918,559.048523 
	C677.311157,560.060120 682.765015,559.230347 688.616028,559.696777 
z"
      />
      <path
        fill="#0C8E36"
        opacity="1.000000"
        stroke="none"
        d="
M836.295471,1159.610596 
	C836.091248,1161.727661 836.035034,1163.417236 835.974365,1165.529907 
	C834.923340,1171.000610 835.781799,1176.114014 835.307312,1181.616211 
	C835.113098,1183.746704 835.057190,1185.447144 835.000244,1187.573486 
	C833.860657,1193.360962 834.811707,1198.794556 834.280273,1204.606689 
	C834.066467,1206.713013 834.012756,1208.395020 833.953125,1210.498047 
	C832.895081,1215.977783 833.807983,1221.101562 833.295410,1226.610596 
	C833.091248,1228.727661 833.035034,1230.417236 832.974365,1232.529907 
	C831.923340,1238.000610 832.781799,1243.114014 832.307312,1248.616211 
	C832.113098,1250.746704 832.057129,1252.447144 832.000244,1254.573486 
	C830.860657,1260.360962 831.811707,1265.794556 831.280273,1271.606689 
	C831.066467,1273.713013 831.012756,1275.395020 830.953125,1277.498047 
	C829.895081,1282.977783 830.807983,1288.101562 830.295410,1293.610596 
	C830.091248,1295.727661 830.035034,1297.417236 829.974365,1299.529907 
	C828.923340,1305.000610 829.781799,1310.114014 829.307312,1315.616211 
	C829.113037,1317.746704 829.057129,1319.447144 829.000244,1321.573486 
	C827.860657,1327.360962 828.811707,1332.794556 828.280273,1338.606689 
	C828.066467,1340.713013 828.012756,1342.395020 827.953125,1344.498047 
	C826.895081,1349.977783 827.807983,1355.101562 827.295410,1360.610596 
	C827.091187,1362.727661 827.035034,1364.417236 826.974365,1366.529907 
	C825.923340,1372.000610 826.781799,1377.114014 826.307312,1382.616211 
	C822.417664,1400.249146 829.145569,1415.752686 833.973328,1431.587158 
	C851.342712,1488.556885 868.653931,1545.544189 885.987671,1602.524780 
	C886.987427,1605.811157 887.991821,1609.096191 889.182922,1613.001221 
	C886.204163,1613.001221 883.613586,1613.001099 881.023010,1613.001099 
	C861.529724,1613.001099 842.035889,1612.927856 822.543518,1613.065430 
	C818.816040,1613.091675 817.075928,1612.241821 815.609131,1608.271362 
	C810.918640,1595.575195 805.370667,1583.196289 800.182983,1570.682983 
	C794.029114,1555.839233 787.970459,1540.955566 781.751099,1526.139526 
	C775.394409,1510.996460 768.777222,1495.962158 762.486694,1480.792236 
	C755.773865,1464.603516 749.640747,1448.166382 742.599182,1432.125366 
	C738.996826,1423.918945 738.809143,1415.524780 738.031250,1406.936157 
	C736.938049,1394.866577 736.893921,1382.731445 735.226440,1370.682007 
	C734.471802,1365.228760 734.658203,1359.577271 734.149719,1353.994751 
	C733.048523,1341.905640 733.090393,1329.714722 732.082886,1317.613892 
	C730.869995,1303.047485 730.211121,1288.441162 728.958069,1273.895874 
	C727.961243,1262.324341 727.352844,1250.705933 726.355713,1239.135742 
	C725.770935,1232.350098 725.546814,1225.319702 724.944946,1218.512939 
	C724.281799,1211.012207 724.624023,1203.443237 723.253784,1195.930176 
	C722.298035,1190.689453 722.364136,1185.101685 722.242554,1179.740845 
	C721.958618,1167.214966 720.468689,1154.782837 719.773193,1142.304932 
	C719.405334,1135.705200 720.242920,1128.881104 718.131165,1122.283813 
	C717.064026,1118.950195 718.429260,1115.717651 720.727356,1112.707764 
	C736.828857,1091.618896 752.747253,1070.390259 768.733093,1049.213135 
	C777.349487,1037.798828 786.057068,1026.452393 794.563232,1014.956726 
	C797.051941,1011.593262 798.425598,1011.495483 800.525024,1015.334656 
	C811.185669,1034.829346 822.036377,1054.220215 832.824890,1073.644897 
	C834.815369,1077.228760 836.825989,1080.801514 839.031311,1084.674438 
	C839.731201,1087.353027 839.403809,1089.760986 839.318970,1092.589966 
	C839.119263,1094.716064 839.049072,1096.409912 838.974365,1098.528320 
	C837.923340,1104.000610 838.781799,1109.114014 838.307312,1114.616211 
	C838.113037,1116.746704 838.057129,1118.447144 838.000244,1120.573486 
	C836.860657,1126.360962 837.811707,1131.794556 837.280273,1137.606689 
	C837.066467,1139.713013 837.012756,1141.395020 836.953125,1143.498047 
	C835.895081,1148.977783 836.807983,1154.101562 836.295471,1159.610596 
z"
      />
      <path
        fill="#0C8E37"
        opacity="1.000000"
        stroke="none"
        d="
M479.738831,764.687256 
	C480.556580,784.108887 482.374695,802.984253 485.906006,821.718018 
	C487.613312,830.775330 492.721710,836.063293 501.047943,839.337341 
	C507.001282,841.678284 512.811035,844.372925 518.977661,846.155518 
	C521.330383,846.835571 521.960754,847.883911 521.529358,850.724670 
	C519.720886,862.633850 518.459473,874.626160 517.000549,886.588379 
	C515.640869,897.736755 514.239197,908.880371 512.954285,920.037354 
	C512.548645,923.559326 509.283020,923.952759 507.211731,924.774780 
	C485.313049,933.464600 463.800629,943.051331 442.144592,952.305969 
	C423.958405,960.077759 405.632690,967.522461 387.393311,975.170593 
	C379.709198,978.392700 372.057098,981.696472 364.465881,985.129822 
	C363.023071,985.782410 361.547028,986.539429 360.418427,985.506714 
	C359.485168,984.652771 360.201904,983.154236 360.507751,981.834534 
	C361.022247,979.614685 360.883270,977.243347 361.024414,974.491211 
	C362.135193,969.335266 361.174622,964.547302 361.704407,959.385254 
	C369.011627,835.374695 409.612244,723.577393 480.276672,622.310852 
	C481.357178,628.344543 479.235229,634.150391 479.975952,640.495972 
	C478.865753,645.664062 479.828400,650.451965 479.274445,655.606934 
	C479.053741,658.026184 478.997803,660.027954 478.933716,662.458618 
	C478.350861,663.793396 478.488037,664.812073 478.489410,665.799500 
	C478.525360,691.250183 478.398865,716.701050 478.772217,742.580078 
	C479.002319,745.040527 479.008942,747.072632 479.068054,749.536865 
	C479.937164,754.721924 479.224701,759.519226 479.738831,764.687256 
z"
      />
      <path
        fill="#0D8F37"
        opacity="1.000000"
        stroke="none"
        d="
M558.724121,933.053406 
	C548.747070,929.729126 539.132202,926.570374 529.526733,923.383179 
	C527.378540,922.670349 525.790283,922.581421 526.743958,918.845886 
	C528.411926,912.312378 528.258911,905.329407 529.085693,898.561279 
	C529.869507,892.144897 530.995728,885.771179 531.853271,879.362854 
	C532.737610,872.753601 533.460327,866.122925 534.289062,859.505981 
	C535.131042,852.783142 536.067200,846.071716 536.863525,839.343689 
	C537.360474,835.145447 537.790405,830.932312 538.036438,826.713379 
	C538.254150,822.979309 539.209778,820.666626 543.768921,820.928772 
	C561.308105,821.937439 578.873962,822.431946 596.389648,823.932434 
	C602.658325,824.469482 609.012268,823.508179 615.267578,824.926819 
	C616.670471,825.244995 617.691895,825.272095 617.986572,827.058167 
	C620.607483,842.942444 623.283264,858.818054 626.014343,874.683838 
	C628.466248,888.927612 630.924927,903.171387 633.573608,917.379211 
	C634.179199,920.627625 634.449585,922.219971 630.215881,923.351929 
	C612.719788,928.029968 595.395813,933.354187 578.029480,938.511292 
	C576.437622,938.984009 575.131409,938.514465 573.739624,938.055786 
	C568.854492,936.445557 563.972717,934.825134 558.724121,933.053406 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M468.442291,1615.068115 
	C469.105377,1614.799927 470.231720,1614.460571 471.359375,1614.456177 
	C517.613342,1614.275269 563.867432,1614.124512 610.584961,1614.064941 
	C609.928711,1615.174561 608.543884,1614.892944 607.239868,1614.895630 
	C561.128601,1614.989014 515.017395,1615.070190 468.442291,1615.068115 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M660.376343,1614.039795 
	C661.044434,1613.770386 662.178589,1613.458252 663.313904,1613.453979 
	C708.923523,1613.278320 754.533142,1613.130493 800.603638,1613.094482 
	C799.915466,1614.156250 798.537720,1613.893921 797.229248,1613.896484 
	C751.767151,1613.984863 706.305054,1614.062012 660.376343,1614.039795 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1654.406006,1068.713623 
	C1654.183105,1041.578979 1654.170288,1014.109497 1654.241577,986.640198 
	C1654.276978,972.990417 1654.466675,959.341125 1654.785400,945.335632 
	C1654.990845,972.628479 1655.035645,1000.277283 1654.987793,1027.926025 
	C1654.964478,1041.410400 1654.768555,1054.894409 1654.406006,1068.713623 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1652.390869,1400.709229 
	C1652.212891,1373.237915 1652.273682,1345.436279 1652.364502,1317.634766 
	C1652.408081,1304.314087 1652.508423,1290.993774 1652.772949,1277.310181 
	C1652.971680,1304.603149 1653.018066,1332.259399 1652.972656,1359.915283 
	C1652.950562,1373.403320 1652.757568,1386.891235 1652.390869,1400.709229 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1656.406128,736.713562 
	C1656.182495,709.584778 1656.163818,682.121094 1656.241699,654.657715 
	C1656.280396,641.012756 1656.496704,627.368347 1656.815796,613.360840 
	C1657.000488,640.642761 1657.039185,668.287598 1656.987549,695.932251 
	C1656.962402,709.414551 1656.768433,722.896606 1656.406128,736.713562 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1655.406250,902.713562 
	C1655.183228,875.578918 1655.170410,848.109436 1655.241699,820.640137 
	C1655.277100,806.990417 1655.466797,793.341064 1655.785400,779.335632 
	C1655.990845,806.628479 1656.035645,834.277283 1655.987793,861.926025 
	C1655.964478,875.410400 1655.768677,888.894531 1655.406250,902.713562 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1653.390869,1234.709229 
	C1653.212158,1207.241943 1653.271362,1179.444336 1653.362549,1151.646851 
	C1653.406128,1138.328491 1653.510010,1125.010254 1653.785400,1111.336182 
	C1653.985352,1138.629395 1654.023315,1166.278320 1653.972412,1193.927124 
	C1653.947510,1207.411255 1653.757080,1220.895142 1653.390869,1234.709229 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1535.609253,1138.290771 
	C1535.787109,1163.762085 1535.726318,1189.563599 1535.635498,1215.365112 
	C1535.592041,1227.685791 1535.491577,1240.006226 1535.227051,1252.689819 
	C1535.028320,1227.396851 1534.982056,1201.740601 1535.027344,1176.084717 
	C1535.049316,1163.596680 1535.242554,1151.108765 1535.609253,1138.290771 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1523.345215,1239.691040 
	C1522.775391,1213.892334 1522.973267,1187.762695 1523.390869,1161.632446 
	C1523.582397,1149.647583 1523.524902,1137.658691 1523.771240,1125.308838 
	C1523.976196,1150.433350 1524.036987,1175.920776 1523.985229,1201.407837 
	C1523.959595,1214.057983 1523.727539,1226.707520 1523.345215,1239.691040 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M902.970459,773.618286 
	C901.950317,772.567261 902.443298,770.856750 902.436951,769.239380 
	C902.313293,737.481934 902.229858,705.724182 902.185852,673.502869 
	C903.470215,674.479980 902.978394,676.219116 902.979553,677.832275 
	C903.001709,709.602844 902.989624,741.373413 902.970459,773.618286 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M917.045410,946.316772 
	C918.020630,947.377258 917.559326,949.084045 917.565491,950.707825 
	C917.686646,982.483276 917.770691,1014.258789 917.814575,1046.498169 
	C916.529968,1045.520264 917.021301,1043.780151 917.020325,1042.165894 
	C917.001160,1010.376038 917.016296,978.586182 917.045410,946.316772 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M905.970520,1378.618530 
	C905.055298,1377.909302 905.434021,1376.529907 905.429749,1375.237793 
	C905.324402,1343.149170 905.244507,1311.060547 905.210144,1278.509033 
	C906.460938,1279.500488 905.978760,1281.234863 905.979919,1282.850098 
	C906.001709,1314.614746 905.989624,1346.379517 905.970520,1378.618530 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M904.954834,1176.682373 
	C904.082458,1175.962402 904.432434,1174.588013 904.428284,1173.290039 
	C904.326904,1141.519409 904.248840,1109.748657 904.237305,1077.518433 
	C905.364990,1078.368896 904.985229,1079.924194 904.985718,1081.385498 
	C904.996399,1112.991333 904.983704,1144.597046 904.954834,1176.682373 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M918.063049,1148.223877 
	C918.256287,1149.033325 918.562317,1150.330322 918.566772,1151.628418 
	C918.676331,1183.427124 918.753906,1215.225952 918.776611,1247.486084 
	C917.628967,1246.647583 918.014832,1245.087524 918.014526,1243.626221 
	C918.007324,1211.988037 918.023499,1180.349976 918.063049,1148.223877 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M903.926758,974.905640 
	C903.736816,974.111206 903.437988,972.814880 903.433594,971.517517 
	C903.324463,939.670044 903.246643,907.822510 903.223755,875.513550 
	C904.367676,876.346375 903.985657,877.900330 903.985840,879.356201 
	C903.989502,911.038574 903.970032,942.720886 903.926758,974.905640 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M915.062988,543.223877 
	C915.256287,544.033325 915.562256,545.330261 915.566711,546.628296 
	C915.675232,578.426208 915.751770,610.224182 915.763184,642.481750 
	C914.634399,641.630127 915.014648,640.073364 915.014282,638.610901 
	C915.007202,606.977905 915.023499,575.344849 915.062988,543.223877 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M916.073242,745.092896 
	C916.263367,745.887207 916.562683,747.183472 916.567261,748.480835 
	C916.677307,780.329956 916.756042,812.179138 916.790283,844.491333 
	C915.627075,843.672302 916.014526,842.114807 916.014343,840.660156 
	C916.010620,808.971924 916.030090,777.283630 916.073242,745.092896 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M919.073364,1350.093262 
	C919.263428,1350.721313 919.563171,1351.851318 919.567017,1352.982544 
	C919.672180,1383.993286 919.747131,1415.004150 919.733826,1446.469727 
	C918.732788,1445.754883 919.008484,1444.378662 919.008606,1443.069580 
	C919.012390,1412.244995 919.030029,1381.420288 919.073364,1350.093262 
z"
      />
      <path
        fill="#AAC99F"
        opacity="1.000000"
        stroke="none"
        d="
M1522.376465,1363.716309 
	C1522.137451,1348.421387 1522.052368,1332.776733 1522.121338,1317.132568 
	C1522.177856,1304.319946 1522.417969,1291.508057 1522.775146,1278.338867 
	C1523.277466,1306.445435 1523.306152,1334.907715 1522.376465,1363.716309 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1657.345459,571.690063 
	C1657.129517,544.643433 1657.157471,517.263306 1657.637207,489.437286 
	C1658.027222,514.795105 1657.971558,540.598816 1657.891602,566.402527 
	C1657.886475,568.054199 1657.694580,569.705322 1657.345459,571.690063 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M479.078705,742.545044 
	C478.707642,739.405090 478.202087,735.803894 478.167114,732.197998 
	C477.945557,709.346863 477.535614,686.492737 478.764404,663.268372 
	C478.929962,672.511047 478.911560,682.134705 478.943787,691.758240 
	C479.000000,708.532715 479.087402,725.307129 479.078705,742.545044 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M901.954834,571.682312 
	C901.786316,571.869019 901.509705,571.576477 901.509338,571.283569 
	C901.475098,546.401672 901.462280,521.519714 901.719666,496.320221 
	C901.986084,521.069397 901.980835,546.136108 901.954834,571.682312 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1534.593994,1292.286377 
	C1535.205811,1316.743286 1535.209106,1341.533203 1534.236938,1366.669434 
	C1534.126953,1342.220215 1534.238037,1317.420776 1534.593994,1292.286377 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M609.473755,546.091064 
	C615.584778,544.820557 622.248901,545.044556 628.864197,545.027100 
	C646.996399,544.979187 665.138916,544.484009 683.623657,545.833130 
	C659.304688,546.063843 634.620361,546.118347 609.473755,546.091064 
z"
      />
      <path
        fill="#B3CEA9"
        opacity="1.000000"
        stroke="none"
        d="
M753.373779,693.707275 
	C753.069031,672.993225 753.009033,651.945557 753.029053,630.433716 
	C754.695435,633.274963 753.839355,636.809692 753.888916,640.210571 
	C754.146912,657.931335 754.346985,675.656250 753.373779,693.707275 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1114.483643,632.386902 
	C1114.755615,650.041992 1114.794922,668.032043 1114.763428,686.481567 
	C1114.468140,686.330322 1114.046387,685.719116 1114.047852,685.109009 
	C1114.089600,667.646545 1114.173828,650.184204 1114.483643,632.386902 
z"
      />
      <path
        fill="#B3CEA9"
        opacity="1.000000"
        stroke="none"
        d="
M1668.981323,1005.999146 
	C1668.981323,1012.282288 1668.981323,1018.065613 1668.981323,1023.848877 
	C1668.748291,1023.849121 1668.515259,1023.849304 1668.282227,1023.849548 
	C1668.282227,1007.334045 1668.282227,990.818481 1668.282227,974.302979 
	C1668.515259,974.299805 1668.748291,974.296631 1668.981323,974.293457 
	C1668.981323,984.695374 1668.981323,995.097351 1668.981323,1005.999146 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1072.501831,1089.378174 
	C1072.658081,1106.162109 1072.575928,1123.277710 1072.268677,1140.743652 
	C1072.116943,1123.965942 1072.190063,1106.837891 1072.501831,1089.378174 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1060.477783,1158.633301 
	C1060.327148,1141.772217 1060.421387,1124.582764 1060.707397,1106.991455 
	C1060.840454,1123.828125 1060.781616,1141.066528 1060.477783,1158.633301 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1071.501831,1193.378174 
	C1071.658203,1210.162109 1071.575928,1227.277710 1071.268677,1244.743652 
	C1071.116821,1227.965942 1071.190063,1210.837891 1071.501831,1193.378174 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1059.516479,1262.613037 
	C1059.358154,1245.834229 1059.432373,1228.720703 1059.731567,1211.256714 
	C1059.887329,1228.030273 1059.818237,1245.154175 1059.516479,1262.613037 
z"
      />
      <path
        fill="#D2E2CC"
        opacity="1.000000"
        stroke="none"
        d="
M369.304230,1615.630127 
	C385.685760,1615.255249 402.389648,1615.144531 419.558044,1615.111206 
	C419.266235,1616.007324 418.264343,1616.002319 417.268402,1616.000244 
	C401.387787,1615.966187 385.507172,1615.930054 369.304230,1615.630127 
z"
      />
      <path
        fill="#D2E2CC"
        opacity="1.000000"
        stroke="none"
        d="
M491.529541,694.300293 
	C491.847351,707.681030 491.906525,721.387390 491.888428,735.558289 
	C490.597595,734.791199 491.007233,733.225098 491.014282,731.784668 
	C491.074738,719.398315 491.179413,707.012085 491.529541,694.300293 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1389.073120,690.092285 
	C1390.139404,700.884399 1389.410156,712.199524 1389.291870,723.884766 
	C1389.075317,713.041138 1389.060181,701.818054 1389.073120,690.092285 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1658.130615,488.525024 
	C1658.088745,488.991333 1657.792603,488.990540 1657.644775,488.992523 
	C1657.485596,484.007080 1657.313477,479.012970 1657.521240,474.034668 
	C1657.654053,470.849579 1656.734985,469.414703 1653.356323,469.845520 
	C1651.226196,470.117096 1649.043823,469.978119 1646.423584,469.938232 
	C1649.087524,468.400879 1652.426636,469.145447 1655.670166,468.916687 
	C1658.110352,468.744598 1658.208008,470.427338 1658.202026,472.191742 
	C1658.184204,477.480713 1658.181274,482.769745 1658.130615,488.525024 
z"
      />
      <path
        fill="#B3CEA9"
        opacity="1.000000"
        stroke="none"
        d="
M728.546082,878.927002 
	C719.259216,880.919067 709.467163,879.948914 699.327759,879.231323 
	C708.676758,878.964844 718.379700,878.903992 728.546082,878.927002 
z"
      />
      <path
        fill="#D2E2CC"
        opacity="1.000000"
        stroke="none"
        d="
M1029.701050,344.546204 
	C1020.315125,344.861176 1010.608337,344.911407 1000.438110,344.874817 
	C1006.267395,343.052734 1012.684937,344.334564 1019.038269,344.041504 
	C1022.474609,343.883057 1025.932129,344.186401 1029.701050,344.546204 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1103.970215,713.618896 
	C1102.844727,705.746277 1103.208252,697.352478 1103.209717,688.508789 
	C1104.942627,696.370422 1103.562378,704.783447 1103.970215,713.618896 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M765.583618,701.286987 
	C766.398071,709.072327 765.755737,717.167053 765.175171,725.630859 
	C765.109131,717.870117 765.222473,709.745117 765.583618,701.286987 
z"
      />
      <path
        fill="#B3CEA9"
        opacity="1.000000"
        stroke="none"
        d="
M1022.371277,1653.031128 
	C1029.944458,1651.958496 1038.032471,1652.170532 1046.567383,1652.029053 
	C1039.028564,1653.896362 1030.907837,1652.911255 1022.371277,1653.031128 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M983.290405,1652.391113 
	C991.082214,1652.287964 999.204285,1652.435791 1007.689453,1652.773438 
	C999.901367,1653.411743 991.757874,1653.269165 983.290405,1652.391113 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1560.308594,1469.347168 
	C1567.755859,1468.667358 1575.512573,1469.280396 1583.638184,1469.815674 
	C1576.206421,1470.348877 1568.420654,1470.167725 1560.308594,1469.347168 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1340.294678,1462.375977 
	C1347.752441,1461.637573 1355.510010,1462.312500 1363.638428,1462.815552 
	C1356.199707,1463.384155 1348.408325,1463.108398 1340.294678,1462.375977 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1623.294922,1471.376099 
	C1630.752319,1470.637939 1638.509888,1471.312866 1646.638306,1471.815674 
	C1639.199707,1472.384155 1631.408447,1472.108398 1623.294922,1471.376099 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1377.926880,696.908813 
	C1377.652344,689.931580 1377.405762,682.451660 1377.209473,674.508728 
	C1378.923340,681.454651 1377.601074,688.956421 1377.926880,696.908813 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1529.290527,1468.400635 
	C1536.428467,1467.600342 1543.867920,1468.375854 1551.683350,1468.782959 
	C1544.564209,1469.395874 1537.090210,1469.112305 1529.290527,1468.400635 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1592.290527,1470.400635 
	C1599.428101,1469.613770 1606.868042,1470.370850 1614.683350,1470.782959 
	C1607.564209,1471.396606 1600.090088,1471.121338 1592.290527,1470.400635 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M492.654358,658.309937 
	C492.737457,665.420532 492.576569,672.864502 492.216309,680.664307 
	C491.632996,673.552185 491.776215,666.093506 492.654358,658.309937 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1403.294678,1464.375977 
	C1410.441162,1463.634888 1417.889160,1464.306030 1425.716309,1464.759277 
	C1418.590210,1465.419678 1411.104248,1465.089844 1403.294678,1464.375977 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1372.287109,1463.416016 
	C1379.417114,1462.572876 1386.852295,1463.410889 1394.657837,1463.794678 
	C1387.542969,1464.394043 1380.080322,1464.113159 1372.287109,1463.416016 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1309.287109,1461.416016 
	C1316.423218,1460.570435 1323.864624,1461.416626 1331.683472,1461.782715 
	C1324.564697,1462.414307 1317.091553,1462.104980 1309.287109,1461.416016 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1435.286377,1465.406006 
	C1442.417236,1464.586304 1449.857178,1465.366943 1457.663818,1465.785156 
	C1450.546021,1466.391235 1443.082397,1466.105591 1435.286377,1465.406006 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1103.534180,649.603760 
	C1103.373779,642.830261 1103.440186,635.718933 1103.731445,628.257019 
	C1103.891357,635.026306 1103.826050,642.146118 1103.534180,649.603760 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1466.290527,1466.400635 
	C1473.022583,1466.234497 1480.082886,1466.322632 1487.607666,1466.297363 
	C1484.558838,1468.501953 1480.708618,1466.762695 1477.030762,1467.008423 
	C1473.583252,1467.238892 1470.091064,1466.799438 1466.290527,1466.400635 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M623.589966,558.945068 
	C617.035156,560.052063 609.960449,559.908264 602.433960,559.959412 
	C608.958923,558.260498 616.064880,559.031006 623.589966,558.945068 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1234.366699,546.477905 
	C1241.193604,546.324341 1248.349243,546.415527 1255.884644,546.708130 
	C1249.074707,546.847229 1241.885010,546.785034 1234.366699,546.477905 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1377.516113,754.613159 
	C1377.358032,748.130005 1377.432373,741.312073 1377.708008,734.114624 
	C1377.855835,740.582886 1377.802246,747.430542 1377.516113,754.613159 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M764.925903,617.448608 
	C766.270569,623.643799 765.949768,630.382507 765.950317,637.566040 
	C764.193115,631.393188 765.212036,624.617065 764.925903,617.448608 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1188.380615,546.970337 
	C1194.244385,545.846802 1200.643066,546.202698 1207.486328,546.223511 
	C1201.631836,547.843384 1195.213745,546.607910 1188.380615,546.970337 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1501.354370,1467.159302 
	C1507.518555,1467.071655 1513.913696,1467.328003 1520.664429,1467.783691 
	C1514.531128,1468.255371 1508.044434,1468.435669 1501.354370,1467.159302 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M491.945129,748.409912 
	C493.054565,754.294800 492.889191,760.706482 492.959473,767.566223 
	C491.152222,761.719910 492.122223,755.264160 491.945129,748.409912 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M752.400696,723.710327 
	C752.295654,717.579651 752.444519,711.120605 752.770020,704.289551 
	C753.415894,710.414124 753.173279,716.900146 752.400696,723.710327 
z"
      />
      <path
        fill="#D2E2CC"
        opacity="1.000000"
        stroke="none"
        d="
M657.702026,558.546570 
	C651.982178,558.861450 645.941467,558.911682 639.437744,558.875122 
	C645.070618,557.179504 651.236511,558.115845 657.702026,558.546570 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M828.376343,1338.705811 
	C827.657776,1333.575684 828.267639,1328.154297 828.816406,1322.362305 
	C829.362610,1327.470703 829.123840,1332.928589 828.376343,1338.705811 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M831.376343,1271.705811 
	C830.657776,1266.575684 831.267639,1261.154297 831.816406,1255.362305 
	C832.362610,1260.470703 832.123840,1265.928589 831.376343,1271.705811 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M840.625488,1365.294556 
	C841.325562,1370.424316 840.746643,1375.847168 840.185547,1381.639160 
	C839.646423,1376.530396 839.858643,1371.071777 840.625488,1365.294556 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M842.642700,1320.306152 
	C843.346558,1325.435547 842.683105,1330.861572 842.204712,1336.656616 
	C841.636047,1331.543213 841.856689,1326.086060 842.642700,1320.306152 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M843.625488,1298.294556 
	C844.325562,1303.424316 843.746643,1308.847168 843.185547,1314.639160 
	C842.646423,1309.530396 842.858643,1304.071777 843.625488,1298.294556 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M845.642700,1253.306152 
	C846.346558,1258.435547 845.683105,1263.861572 845.204712,1269.656616 
	C844.636047,1264.543213 844.856689,1259.086060 845.642700,1253.306152 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M846.625488,1231.294556 
	C847.325562,1236.424316 846.746643,1241.847168 846.185547,1247.639160 
	C845.646423,1242.530396 845.858643,1237.071777 846.625488,1231.294556 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M834.376343,1204.705811 
	C833.657776,1199.575684 834.267639,1194.154297 834.816406,1188.362305 
	C835.362610,1193.470703 835.123840,1198.928589 834.376343,1204.705811 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M848.642700,1186.306152 
	C849.346558,1191.435547 848.683105,1196.861572 848.204712,1202.656616 
	C847.636047,1197.543213 847.856689,1192.086060 848.642700,1186.306152 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M849.625488,1164.294556 
	C850.325562,1169.424316 849.746643,1174.847168 849.185547,1180.639160 
	C848.646423,1175.530396 848.858643,1170.071777 849.625488,1164.294556 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M837.376343,1137.705811 
	C836.657776,1132.575684 837.267639,1127.154297 837.816406,1121.362305 
	C838.362610,1126.470703 838.123840,1131.928589 837.376343,1137.705811 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M851.652954,1119.308105 
	C852.332703,1124.436890 851.724548,1129.867554 851.214355,1135.662842 
	C850.648254,1130.547485 850.841797,1125.089722 851.652954,1119.308105 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M852.625488,1097.294556 
	C853.348389,1102.424927 852.699341,1107.845703 852.185547,1113.639160 
	C851.634521,1108.530151 851.863098,1103.071899 852.625488,1097.294556 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M801.005920,992.446045 
	C803.950378,992.535095 805.424927,994.460938 806.135620,997.561279 
	C802.943176,997.759277 801.295166,995.978149 801.005920,992.446045 
z"
      />
      <path
        fill="#B3CEA9"
        opacity="1.000000"
        stroke="none"
        d="
M701.297974,866.359253 
	C706.461670,866.196594 711.953979,866.284241 717.758667,866.650146 
	C712.580261,867.300903 707.098938,867.184448 701.297974,866.359253 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M688.713867,559.593872 
	C683.583496,559.699158 678.118713,559.559875 672.283447,559.240234 
	C677.412109,558.568237 682.898254,558.815796 688.713867,559.593872 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M850.583923,1142.286377 
	C851.396301,1147.095459 850.643982,1152.200073 850.216553,1157.683228 
	C849.606323,1152.894165 849.875671,1147.754395 850.583923,1142.286377 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M832.416382,1248.713867 
	C831.609009,1243.905029 832.387878,1238.801392 832.783997,1233.317383 
	C833.397522,1238.106201 833.138367,1243.245972 832.416382,1248.713867 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M826.416382,1382.713867 
	C825.609009,1377.905029 826.387878,1372.801392 826.783997,1367.317383 
	C827.397522,1372.106201 827.138367,1377.245972 826.416382,1382.713867 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M836.400940,1159.710449 
	C835.645325,1154.893921 836.314209,1149.783813 836.770874,1144.290649 
	C837.403137,1149.083984 837.126404,1154.235352 836.400940,1159.710449 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M1438.709961,1482.590576 
	C1433.905518,1483.382080 1428.815308,1482.590820 1423.348633,1482.195801 
	C1428.131714,1481.629883 1433.261108,1481.838623 1438.709961,1482.590576 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M827.400940,1360.710449 
	C826.645325,1355.893921 827.314209,1350.783813 827.770874,1345.290649 
	C828.403137,1350.083984 828.126404,1355.235352 827.400940,1360.710449 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M841.590454,1343.290039 
	C842.370605,1348.106689 841.615906,1353.211304 841.220215,1358.704346 
	C840.589050,1353.912964 840.858704,1348.762573 841.590454,1343.290039 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M835.416382,1181.713867 
	C834.609009,1176.905029 835.387878,1171.801392 835.783997,1166.317383 
	C836.397522,1171.106201 836.138367,1176.245972 835.416382,1181.713867 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M829.416382,1315.713867 
	C828.609009,1310.905029 829.387878,1305.801392 829.783997,1300.317383 
	C830.397522,1305.106201 830.138367,1310.245972 829.416382,1315.713867 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1417.692383,1481.653076 
	C1412.889160,1482.330566 1407.785645,1481.741699 1402.310669,1481.226562 
	C1407.097412,1480.645752 1412.232910,1480.850464 1417.692383,1481.653076 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1395.710449,1480.599609 
	C1390.914185,1481.355957 1385.830078,1480.643921 1380.368408,1480.175049 
	C1385.141602,1479.635132 1390.265869,1479.836670 1395.710449,1480.599609 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1374.706177,1479.624023 
	C1369.898560,1480.360474 1364.800903,1479.705200 1359.336548,1479.214355 
	C1364.125977,1478.630249 1369.256470,1478.882568 1374.706177,1479.624023 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M830.400940,1293.710449 
	C829.645325,1288.893921 830.314209,1283.783813 830.770874,1278.290649 
	C831.403137,1283.083984 831.126404,1288.235352 830.400940,1293.710449 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M1331.709961,1477.590576 
	C1326.905518,1478.382080 1321.815308,1477.590820 1316.348633,1477.195801 
	C1321.131714,1476.629883 1326.261108,1476.838623 1331.709961,1477.590576 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1536.540894,474.917847 
	C1532.019531,476.135315 1526.946167,475.931213 1521.431641,475.958191 
	C1525.921997,474.312469 1531.037109,475.091675 1536.540894,474.917847 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M844.590454,1276.290039 
	C845.370605,1281.106689 844.615906,1286.211304 844.220215,1291.704346 
	C843.589050,1286.912964 843.858704,1281.762573 844.590454,1276.290039 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M847.590454,1209.290039 
	C848.370605,1214.106689 847.615906,1219.211304 847.220215,1224.704346 
	C846.589050,1219.912964 846.858704,1214.762573 847.590454,1209.290039 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M587.446411,547.073914 
	C591.965027,545.793091 597.046204,546.076660 602.562012,546.033203 
	C598.072815,547.719299 592.949036,546.843811 587.446411,547.073914 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M833.400940,1226.710449 
	C832.645325,1221.893921 833.314209,1216.783813 833.770874,1211.290649 
	C834.403137,1216.083984 834.126404,1221.235352 833.400940,1226.710449 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M931.366333,1449.477783 
	C936.157288,1449.324463 941.275818,1449.415649 946.743896,1449.731567 
	C941.960266,1449.878296 936.827087,1449.800293 931.366333,1449.477783 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1020.633423,1465.522217 
	C1015.842896,1465.675293 1010.724731,1465.583862 1005.256958,1465.267944 
	C1010.040161,1465.121460 1015.172913,1465.199585 1020.633423,1465.522217 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M957.633423,1463.522217 
	C952.842896,1463.675293 947.724792,1463.583862 942.256958,1463.267944 
	C947.040161,1463.121460 952.172913,1463.199585 957.633423,1463.522217 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1411.553223,480.926270 
	C1407.030396,482.144073 1401.953247,481.918915 1396.437988,481.967194 
	C1400.924561,480.245728 1406.048950,481.131042 1411.553223,480.926270 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1432.540894,479.917847 
	C1428.019531,481.135315 1422.946167,480.931213 1417.431641,480.958191 
	C1421.921997,479.312469 1427.037109,480.091675 1432.540894,479.917847 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1277.365601,1460.477417 
	C1282.156738,1460.324097 1287.275757,1460.415283 1292.744385,1460.731445 
	C1287.960449,1460.878174 1282.826904,1460.800049 1277.365601,1460.477417 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1214.365601,1458.477417 
	C1219.156860,1458.324097 1224.276001,1458.415283 1229.744507,1458.731445 
	C1224.960449,1458.878174 1219.826904,1458.800049 1214.365601,1458.477417 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1377.447021,469.073914 
	C1381.969849,467.856537 1387.046875,468.082031 1392.562012,468.033203 
	C1388.075439,469.753998 1382.951172,468.869019 1377.447021,469.073914 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1151.365601,1456.477417 
	C1156.156860,1456.324097 1161.276001,1456.415283 1166.744507,1456.731445 
	C1161.960449,1456.878174 1156.826904,1456.800049 1151.365601,1456.477417 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M838.416382,1114.713867 
	C837.609009,1109.905029 838.387878,1104.801392 838.783997,1099.317383 
	C839.397522,1104.106201 839.138367,1109.245972 838.416382,1114.713867 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1515.535278,475.913208 
	C1511.019409,477.149506 1505.947998,476.928497 1500.437866,476.967163 
	C1504.917725,475.240509 1510.039062,476.142426 1515.535278,475.913208 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1619.535278,470.913208 
	C1615.015625,472.095520 1609.948364,471.932465 1604.437866,471.967163 
	C1608.918701,470.253693 1614.036987,471.113251 1619.535278,470.913208 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1452.621338,478.953918 
	C1448.398071,480.071747 1443.634766,479.959076 1438.422852,479.938110 
	C1442.601318,478.198425 1447.422974,479.140564 1452.621338,478.953918 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M480.041321,764.624512 
	C478.773651,760.413391 479.046234,755.640137 479.043335,750.430054 
	C480.764954,754.606018 479.811371,759.429871 480.041321,764.624512 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1473.587402,477.939331 
	C1469.378418,479.093658 1464.621460,478.923737 1459.422852,478.938080 
	C1463.588867,477.184418 1468.401611,478.140442 1473.587402,477.939331 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1352.714355,1478.584229 
	C1348.230835,1479.362305 1343.451416,1478.684570 1338.288940,1478.229492 
	C1342.750122,1477.598022 1347.568359,1477.866699 1352.714355,1478.584229 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M764.590942,732.288330 
	C765.341492,736.773193 764.743896,741.548828 764.220154,746.704895 
	C763.611389,742.245605 763.884155,737.427917 764.590942,732.288330 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M361.598999,959.288574 
	C361.701721,963.747498 361.551300,968.533447 361.215271,973.683105 
	C360.605957,969.224731 360.811829,964.416565 361.598999,959.288574 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M1494.549927,476.922119 
	C1490.348511,478.042328 1485.604736,477.920410 1480.416260,477.917908 
	C1484.576050,476.183197 1489.376709,477.136505 1494.549927,476.922119 
z"
      />
      <path
        fill="#B9D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M1639.626221,469.959351 
	C1635.411865,471.187500 1630.639038,470.927460 1625.430420,470.958130 
	C1629.604736,469.207550 1634.429565,470.167419 1639.626221,469.959351 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1390.554688,481.926361 
	C1386.356445,483.123993 1381.604126,482.918579 1376.413818,482.925293 
	C1380.577515,481.214630 1385.378296,482.133270 1390.554688,481.926361 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1053.710938,345.599487 
	C1049.245117,345.703888 1044.452393,345.554871 1039.288818,345.229431 
	C1043.751709,344.577789 1048.570801,344.823364 1053.710938,345.599487 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1026.394531,1452.533447 
	C1030.852173,1452.373291 1035.646484,1452.439331 1040.801270,1452.719482 
	C1036.351685,1452.875732 1031.541382,1452.817627 1026.394531,1452.533447 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M988.614136,1464.483887 
	C984.129456,1464.641235 979.311157,1464.566528 974.114868,1464.291260 
	C978.584717,1464.144287 983.432617,1464.197998 988.614136,1464.483887 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1246.385742,1459.515747 
	C1250.870972,1459.358276 1255.690063,1459.432861 1260.886963,1459.708252 
	C1256.416382,1459.855469 1251.567993,1459.801636 1246.385742,1459.515747 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1183.385742,1457.515747 
	C1187.870972,1457.358276 1192.689819,1457.432861 1197.886841,1457.708252 
	C1193.416382,1457.855469 1188.567993,1457.801636 1183.385742,1457.515747 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1120.370850,1455.488037 
	C1124.897827,1455.336548 1129.754150,1455.426147 1135.010742,1455.707520 
	C1130.507324,1455.842529 1125.603760,1455.785767 1120.370850,1455.488037 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M994.376221,1451.497559 
	C998.900085,1451.345093 1003.754822,1451.430542 1009.009888,1451.707764 
	C1004.509216,1451.844727 999.608154,1451.790161 994.376221,1451.497559 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M963.385620,1450.515869 
	C967.870789,1450.358521 972.689697,1450.433105 977.886475,1450.708496 
	C973.416077,1450.855591 968.567749,1450.801758 963.385620,1450.515869 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M839.643066,1387.305176 
	C840.242249,1391.767944 839.946106,1396.537842 839.205078,1401.656738 
	C838.739136,1397.210205 838.839783,1392.416260 839.643066,1387.305176 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1051.622803,1466.501953 
	C1047.099609,1466.654541 1042.245850,1466.569092 1036.991943,1466.292236 
	C1041.491821,1466.155151 1046.391968,1466.209473 1051.622803,1466.501953 
z"
      />
      <path
        fill="#C0D6B7"
        opacity="1.000000"
        stroke="none"
        d="
M1598.549927,471.922119 
	C1594.348511,473.042328 1589.604736,472.920410 1584.416260,472.917908 
	C1588.576050,471.183197 1593.376709,472.136505 1598.549927,471.922119 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1082.605225,1467.466309 
	C1078.147949,1467.626099 1073.353882,1467.559937 1068.199219,1467.279785 
	C1072.648560,1467.124023 1077.458618,1467.182251 1082.605225,1467.466309 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1114.622803,1468.501953 
	C1110.099609,1468.654419 1105.245972,1468.568970 1099.991943,1468.292114 
	C1104.491821,1468.155151 1109.391968,1468.209595 1114.622803,1468.501953 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1577.587402,472.939331 
	C1573.378418,474.093658 1568.621460,473.923737 1563.422852,473.938080 
	C1567.588867,472.184418 1572.401611,473.140442 1577.587402,472.939331 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M1556.621338,473.953918 
	C1552.398071,475.071747 1547.634766,474.959076 1542.422852,474.938110 
	C1546.601318,473.198425 1551.422974,474.140564 1556.621338,473.953918 
z"
      />
      <path
        fill="#BCD4B3"
        opacity="1.000000"
        stroke="none"
        d="
M479.357513,655.694824 
	C478.685364,651.223450 479.206787,646.454773 479.784637,641.317505 
	C480.329956,645.769470 480.152435,650.572021 479.357513,655.694824 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1144.594238,1469.447998 
	C1140.474854,1469.609741 1136.016602,1469.551636 1131.198486,1469.279785 
	C1135.310791,1469.120117 1139.783081,1469.174194 1144.594238,1469.447998 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1263.635376,558.522888 
	C1259.493530,558.676270 1255.025146,558.585510 1250.196533,558.280518 
	C1254.327271,558.137085 1258.817993,558.207886 1263.635376,558.522888 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M925.614990,1462.484131 
	C921.499756,1462.641235 917.051636,1462.566650 912.255493,1462.267700 
	C916.365601,1462.113037 920.823914,1462.182739 925.614990,1462.484131 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M848.112427,1074.002808 
	C849.759521,1075.033447 850.487915,1076.604614 851.137878,1078.589111 
	C848.591858,1078.390137 846.254700,1077.671021 848.112427,1074.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M808.112366,1002.002686 
	C809.759460,1003.033447 810.488342,1004.604675 811.138306,1006.589600 
	C808.592834,1006.390381 806.254639,1005.671509 808.112366,1002.002686 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M813.112366,1011.002686 
	C814.759460,1012.033447 815.488342,1013.604675 816.138306,1015.589600 
	C813.592834,1015.390381 811.254639,1014.671509 813.112366,1011.002686 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M818.112305,1020.002686 
	C819.759399,1021.033264 820.487854,1022.604614 821.137878,1024.589111 
	C818.591797,1024.390137 816.254578,1023.670898 818.112305,1020.002686 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M823.112427,1029.002808 
	C824.759521,1030.033325 825.487854,1031.604736 826.137939,1033.589111 
	C823.591858,1033.390137 821.254700,1032.671021 823.112427,1029.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M828.112427,1038.002808 
	C829.759521,1039.033325 830.487854,1040.604736 831.137939,1042.589111 
	C828.591858,1042.390137 826.254700,1041.671021 828.112427,1038.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M833.112427,1047.002808 
	C834.759521,1048.033325 835.487854,1049.604736 836.137939,1051.589111 
	C833.591858,1051.390137 831.254700,1050.671021 833.112427,1047.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M838.112427,1056.002808 
	C839.759521,1057.033325 840.487854,1058.604736 841.137939,1060.589111 
	C838.591858,1060.390137 836.254700,1059.671021 838.112427,1056.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M843.112427,1065.002808 
	C844.759521,1066.033325 845.487854,1067.604736 846.137939,1069.589111 
	C843.591858,1069.390137 841.254700,1068.671021 843.112427,1065.002808 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1388.045532,653.307373 
	C1388.996582,656.862061 1388.848633,660.954651 1388.762939,665.489990 
	C1387.242798,661.953857 1388.338257,657.827026 1388.045532,653.307373 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1388.522705,748.364868 
	C1388.672241,752.230530 1388.577759,756.422241 1388.291870,761.012146 
	C1388.159912,757.170532 1388.219116,752.930725 1388.522705,748.364868 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1115.063599,707.214111 
	C1115.949097,710.800476 1115.725708,714.931091 1115.776611,719.494446 
	C1114.224243,715.932861 1115.337524,711.773621 1115.063599,707.214111 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1147.357910,867.474487 
	C1150.707031,867.208557 1154.376099,867.184143 1158.499878,867.209595 
	C1155.246338,868.664978 1151.453003,867.964539 1147.357910,867.474487 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1104.936401,740.789612 
	C1104.045532,737.531433 1104.179810,733.730591 1104.185303,729.490356 
	C1105.875244,732.707031 1104.620361,736.562744 1104.936401,740.789612 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1059.048584,1453.509521 
	C1060.070435,1453.124512 1061.141113,1453.082153 1062.606445,1453.122314 
	C1062.925903,1454.323120 1063.148560,1455.712524 1061.534302,1455.847656 
	C1060.226807,1455.957275 1059.448975,1455.083618 1059.048584,1453.509521 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1310.640137,1476.524170 
	C1307.505249,1476.674438 1304.048218,1476.582397 1300.249268,1476.266846 
	C1303.377441,1476.122803 1306.847778,1476.202271 1310.640137,1476.524170 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1191.638794,558.030090 
	C1188.766724,559.037598 1185.328003,558.596130 1181.500366,558.762939 
	C1184.355347,557.294189 1187.812378,558.296753 1191.638794,558.030090 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1376.969849,659.638000 
	C1375.984619,656.763184 1376.355835,653.327515 1376.209717,649.491089 
	C1377.754272,652.335144 1376.682739,655.807800 1376.969849,659.638000 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1227.952148,1472.492188 
	C1226.926392,1472.857788 1225.852661,1472.882812 1224.387939,1472.802979 
	C1224.067871,1471.582275 1223.902710,1470.228516 1225.511475,1470.143311 
	C1226.801880,1470.074829 1227.562256,1470.936035 1227.952148,1472.492188 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1133.290771,480.954224 
	C1135.861084,480.013794 1138.980225,480.245331 1142.510254,480.224335 
	C1139.973022,481.763153 1136.806274,480.673706 1133.290771,480.954224 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1267.627075,1474.503174 
	C1264.760376,1474.653564 1261.567383,1474.567139 1257.983398,1474.291260 
	C1260.828613,1474.156494 1264.064697,1474.211426 1267.627075,1474.503174 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1112.354614,481.970032 
	C1114.901123,480.984314 1118.003662,481.273071 1121.506592,481.237793 
	C1118.984863,482.751129 1115.841919,481.671051 1112.354614,481.970032 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1135.709229,494.046051 
	C1133.141357,495.025726 1130.015503,494.733978 1126.484131,494.789886 
	C1129.015869,493.215210 1132.191406,494.335083 1135.709229,494.046051 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1092.068604,482.925659 
	C1094.706055,482.039886 1097.903076,482.213348 1101.520996,482.185516 
	C1098.921631,483.762970 1095.682129,482.687500 1092.068604,482.925659 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1279.068604,473.925659 
	C1281.706055,473.039886 1284.903076,473.213348 1288.520996,473.185516 
	C1285.921631,474.762970 1282.682129,473.687500 1279.068604,473.925659 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1071.199463,483.936279 
	C1073.798462,483.002289 1076.957397,483.280426 1080.521851,483.185486 
	C1077.966187,484.807068 1074.757324,483.664398 1071.199463,483.936279 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1288.611816,1475.467896 
	C1285.808350,1475.625488 1282.674683,1475.558594 1279.189819,1475.278809 
	C1281.986206,1475.125122 1285.133911,1475.184326 1288.611816,1475.467896 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1216.354980,476.970062 
	C1218.901733,475.982056 1222.005737,476.276917 1225.510986,476.224365 
	C1222.994507,477.765259 1219.844360,476.664978 1216.354980,476.970062 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1245.612671,1473.468384 
	C1242.822998,1473.624756 1239.704102,1473.557373 1236.246216,1473.266602 
	C1239.032593,1473.110352 1242.158081,1473.177368 1245.612671,1473.468384 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1237.290771,475.954224 
	C1239.861084,475.013794 1242.980225,475.245331 1246.510254,475.224335 
	C1243.973022,476.763153 1240.806274,475.673706 1237.290771,475.954224 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1341.291260,470.954224 
	C1343.861816,470.011200 1346.982910,470.250427 1350.515381,470.210541 
	C1347.984009,471.784790 1344.808716,470.664673 1341.291260,470.954224 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1258.198975,474.936249 
	C1260.798340,474.016327 1263.949463,474.247070 1267.514648,474.210541 
	C1264.953857,475.783508 1261.754272,474.674103 1258.198975,474.936249 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1154.198975,479.936249 
	C1156.798340,479.016327 1159.949463,479.247070 1163.514648,479.210541 
	C1160.953857,480.783508 1157.754272,479.674103 1154.198975,479.936249 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1320.354980,471.970062 
	C1322.901245,470.977997 1326.004272,471.262695 1329.510742,471.224335 
	C1326.994507,472.765259 1323.844360,471.664978 1320.354980,471.970062 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1362.198975,469.936249 
	C1364.798340,469.016327 1367.949463,469.247070 1371.514648,469.210541 
	C1368.953857,470.783508 1365.754272,469.674103 1362.198975,469.936249 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1175.199463,478.936279 
	C1177.800171,478.023468 1180.953003,478.225830 1184.521973,478.185486 
	C1181.966187,479.807068 1178.757324,478.664398 1175.199463,478.936279 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1114.801636,495.063965 
	C1112.202393,495.998871 1109.042847,495.720001 1105.478027,495.814941 
	C1108.037354,494.236084 1111.241943,495.319153 1114.801636,495.063965 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1050.291260,484.954224 
	C1052.859009,483.975372 1055.984497,484.266388 1059.515625,484.210571 
	C1056.984009,485.784790 1053.808716,484.664673 1050.291260,484.954224 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1364.645508,483.030151 
	C1362.099243,484.023102 1358.995728,483.737762 1355.489014,483.776062 
	C1358.005493,482.234467 1361.155884,483.335022 1364.645508,483.030151 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1343.709229,484.046051 
	C1341.138428,484.989990 1338.017090,484.749878 1334.484375,484.789856 
	C1337.015869,483.215210 1340.191406,484.335083 1343.709229,484.046051 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1116.045898,732.290405 
	C1117.006958,734.860291 1116.716553,737.990051 1116.815186,741.521484 
	C1115.191528,738.995544 1116.345093,735.810608 1116.045898,732.290405 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1029.354980,485.970062 
	C1031.901245,484.977997 1035.004272,485.262695 1038.510742,485.224335 
	C1035.994507,486.765259 1032.844360,485.664978 1029.354980,485.970062 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1322.802002,485.063965 
	C1320.202271,485.984802 1317.050659,485.753296 1313.484985,485.789917 
	C1316.046265,484.216156 1319.246216,485.325897 1322.802002,485.063965 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1008.354492,486.970032 
	C1010.901123,485.984528 1014.003540,486.272858 1017.506531,486.237854 
	C1014.984680,487.751221 1011.841736,486.670990 1008.354492,486.970032 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1301.932617,486.074463 
	C1299.294800,486.961273 1296.097412,486.786896 1292.479004,486.814941 
	C1295.078613,485.236664 1298.318481,486.312653 1301.932617,486.074463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M988.068726,487.925629 
	C990.706116,487.040039 993.902832,487.213318 997.520508,487.185547 
	C994.921265,488.763000 991.682068,487.687439 988.068726,487.925629 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1281.645996,487.030151 
	C1279.099365,488.016907 1275.996582,487.727264 1272.493286,487.762604 
	C1275.015259,486.248505 1278.158447,487.329071 1281.645996,487.030151 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M967.198975,488.936279 
	C969.798401,488.016266 972.949585,488.247131 976.514648,488.210510 
	C973.953796,489.783783 970.754272,488.673920 967.198975,488.936279 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1260.709595,488.046021 
	C1258.139282,488.987274 1255.019897,488.755096 1251.489624,488.776062 
	C1254.026978,487.236633 1257.193970,488.326294 1260.709595,488.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M946.291321,489.954224 
	C948.861877,489.011200 951.982910,489.250427 955.515259,489.210571 
	C952.984009,490.784912 949.808838,489.664581 946.291321,489.954224 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1239.709229,489.046051 
	C1237.141357,490.025726 1234.015503,489.733978 1230.484131,489.789886 
	C1233.015869,488.215210 1236.191406,489.335083 1239.709229,489.046051 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M925.354980,490.970032 
	C927.901917,489.982117 931.006226,490.276855 934.511719,490.224304 
	C931.995117,491.765076 928.844666,490.665131 925.354980,490.970032 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1156.709595,493.046021 
	C1154.139282,493.987274 1151.019897,493.755096 1147.489624,493.776062 
	C1150.026978,492.236633 1153.193970,493.326294 1156.709595,493.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1270.378296,547.513672 
	C1273.173096,547.359009 1276.293945,547.434021 1279.754150,547.732605 
	C1276.963623,547.885193 1273.834106,547.814270 1270.378296,547.513672 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1197.932617,491.074463 
	C1195.294800,491.961273 1192.097412,491.786896 1188.479004,491.814941 
	C1191.078613,490.236664 1194.318481,491.312653 1197.932617,491.074463 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1177.645996,492.030151 
	C1175.099365,493.016907 1171.996582,492.727264 1168.493286,492.762604 
	C1171.015259,491.248505 1174.158447,492.329071 1177.645996,492.030151 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M927.801880,504.063995 
	C925.202209,504.984802 922.050598,504.753357 918.485046,504.789917 
	C921.046265,503.216156 924.246155,504.325867 927.801880,504.063995 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M948.709717,503.046021 
	C946.139221,503.987366 943.019653,503.754974 939.489014,503.776123 
	C942.026489,502.236755 945.193787,503.326111 948.709717,503.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M969.646118,502.030151 
	C967.099365,503.016907 963.996521,502.727264 960.493225,502.762604 
	C963.015320,501.248474 966.158569,502.329071 969.646118,502.030151 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1218.801636,490.063965 
	C1216.202393,490.998871 1213.042847,490.720001 1209.478027,490.814941 
	C1212.037354,489.236084 1215.241943,490.319153 1218.801636,490.063965 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1010.801453,500.063965 
	C1008.200562,500.977814 1005.047485,500.774078 1001.478516,500.814880 
	C1004.034363,499.192322 1007.243408,500.335876 1010.801453,500.063965 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1031.802002,499.063965 
	C1029.202271,499.984833 1026.050537,499.753326 1022.484985,499.789917 
	C1025.046265,498.216064 1028.246216,499.325958 1031.802002,499.063965 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1052.709595,498.046021 
	C1050.139282,498.987274 1047.019897,498.755096 1043.489624,498.776062 
	C1046.026978,497.236633 1049.193970,498.326294 1052.709595,498.046021 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1073.645996,497.030151 
	C1071.099365,498.016907 1067.996582,497.727264 1064.493286,497.762604 
	C1067.015259,496.248505 1070.158447,497.329071 1073.645996,497.030151 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M989.942993,501.074890 
	C987.578857,501.345642 984.748291,501.589325 981.488220,501.762665 
	C983.773376,500.285339 986.672302,501.284729 989.942993,501.074890 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1104.474609,615.643555 
	C1104.324707,613.151489 1104.416382,610.341736 1104.720825,607.185059 
	C1104.860962,609.667419 1104.788452,612.496643 1104.474609,615.643555 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1196.058350,477.925110 
	C1198.422241,477.654449 1201.252197,477.410980 1204.511719,477.237762 
	C1202.226929,478.714325 1199.328491,477.715363 1196.058350,477.925110 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1376.474976,776.642212 
	C1376.326172,774.129395 1376.419434,771.297241 1376.710693,768.100586 
	C1376.844971,770.598267 1376.781006,773.460632 1376.474976,776.642212 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1105.953857,760.717896 
	C1105.073242,758.466858 1105.186768,755.680176 1105.210083,752.476196 
	C1106.760742,754.678711 1105.681396,757.535645 1105.953857,760.717896 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1093.942627,496.074921 
	C1091.578613,496.345673 1088.748169,496.589325 1085.488281,496.762634 
	C1087.773315,495.285309 1090.672119,496.284698 1093.942627,496.074921 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1115.505493,608.366455 
	C1115.657715,610.853333 1115.574829,613.661316 1115.279297,616.815918 
	C1115.134521,614.337585 1115.202515,611.512634 1115.505493,608.366455 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1300.058350,472.925110 
	C1302.373901,472.093750 1305.232300,472.179779 1308.511719,472.237793 
	C1306.226929,473.714294 1303.328491,472.715363 1300.058350,472.925110 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1283.644165,559.525574 
	C1281.151489,559.675232 1278.341064,559.583557 1275.183594,559.279053 
	C1277.666504,559.138977 1280.496460,559.211548 1283.644165,559.525574 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1169.567383,1470.391235 
	C1167.453857,1470.553955 1165.007935,1470.520874 1162.234619,1470.265625 
	C1164.349854,1470.094116 1166.792358,1470.144775 1169.567383,1470.391235 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1117.046387,751.270142 
	C1117.970825,753.193909 1117.715576,755.674011 1117.790039,758.534058 
	C1116.287598,756.656982 1117.288086,754.118042 1117.046387,751.270142 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1387.506592,772.361328 
	C1387.656738,774.508606 1387.572998,776.971863 1387.266357,779.764404 
	C1387.119995,777.621521 1387.196533,775.149414 1387.506592,772.361328 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1096.415771,1454.582764 
	C1098.550537,1454.421387 1101.016479,1454.465332 1103.822510,1454.721313 
	C1101.690674,1454.885010 1099.218628,1454.836670 1096.415771,1454.582764 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1387.030396,634.333496 
	C1388.001953,636.231873 1387.708008,638.694031 1387.762573,641.525696 
	C1386.329468,639.654480 1387.276733,637.150513 1387.030396,634.333496 
z"
      />
      <path
        fill="#D2E2CC"
        opacity="1.000000"
        stroke="none"
        d="
M839.443481,1092.732910 
	C839.187927,1090.636597 839.186401,1088.251099 839.210144,1085.417480 
	C840.870300,1087.369385 839.877869,1089.931763 839.443481,1092.732910 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1174.835938,878.064941 
	C1173.201294,878.931885 1171.025635,878.799255 1168.461182,878.776001 
	C1170.052002,877.372009 1172.286377,878.233643 1174.835938,878.064941 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1375.923950,638.966248 
	C1375.651611,637.230347 1375.405884,635.051270 1375.209961,632.458923 
	C1376.653076,634.080688 1375.760010,636.359680 1375.923950,638.966248 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1289.374023,548.528320 
	C1291.188965,548.375671 1293.319946,548.443848 1295.771973,548.734009 
	C1293.958740,548.887085 1291.824341,548.818054 1289.374023,548.528320 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1298.649658,560.526672 
	C1296.788574,560.672363 1294.615234,560.577759 1292.088867,560.287231 
	C1293.936401,560.156250 1296.136841,560.221313 1298.649658,560.526672 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1170.033936,547.923706 
	C1171.707642,547.102539 1173.922485,547.192017 1176.535767,547.223938 
	C1174.906372,548.633545 1172.637207,547.768005 1170.033936,547.923706 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M907.164734,491.935181 
	C908.783020,490.928833 910.972229,491.192810 913.534546,491.237915 
	C911.936096,492.609833 909.710999,491.773132 907.164734,491.935181 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1106.924072,775.964966 
	C1106.643433,774.228333 1106.389404,772.047668 1106.184326,769.453003 
	C1107.672607,771.066772 1106.752441,773.355713 1106.924072,775.964966 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1070.510132,1297.348145 
	C1070.656250,1298.854370 1070.572021,1300.662598 1070.265869,1302.782227 
	C1070.122559,1301.279053 1070.201172,1299.464600 1070.510132,1297.348145 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1051.469238,1383.663086 
	C1051.326538,1382.151733 1051.420166,1380.341187 1051.734985,1378.218628 
	C1051.872681,1379.725708 1051.789062,1381.544800 1051.469238,1383.663086 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1374.969238,624.695435 
	C1374.030029,623.438477 1374.358276,621.595337 1374.224609,619.441284 
	C1375.538208,620.664551 1374.807129,622.541504 1374.969238,624.695435 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1062.530762,1388.336792 
	C1062.673706,1389.848389 1062.580200,1391.658813 1062.265381,1393.781494 
	C1062.127441,1392.274292 1062.210938,1390.454956 1062.530762,1388.336792 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1048.469238,1417.663086 
	C1048.326538,1416.151733 1048.420166,1414.341187 1048.734985,1412.218628 
	C1048.872681,1413.725708 1048.789062,1415.544800 1048.469238,1417.663086 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1059.530762,1422.336792 
	C1059.673828,1423.848633 1059.580811,1425.659302 1059.265747,1427.781738 
	C1059.127441,1426.274292 1059.210938,1424.454956 1059.530762,1422.336792 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1057.469238,1315.663086 
	C1057.326294,1314.151489 1057.419434,1312.340698 1057.734497,1310.218262 
	C1057.872681,1311.725586 1057.789062,1313.544800 1057.469238,1315.663086 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1116.530762,595.337219 
	C1116.673706,596.848694 1116.580322,598.658936 1116.265381,600.781250 
	C1116.127441,599.274231 1116.210938,597.455139 1116.530762,595.337219 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1386.065430,621.151245 
	C1386.944336,622.462708 1386.761841,624.335449 1386.816162,626.564209 
	C1385.428223,625.310181 1386.194702,623.375427 1386.065430,621.151245 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1118.065674,767.148315 
	C1118.339966,768.543945 1118.588013,770.351135 1118.776123,772.553101 
	C1117.458252,771.281616 1118.183960,769.366150 1118.065674,767.148315 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1067.381836,1453.530762 
	C1068.965942,1453.334229 1070.874146,1453.361084 1073.117310,1453.635498 
	C1071.536865,1453.840210 1069.621460,1453.797363 1067.381836,1453.530762 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1310.653076,561.510315 
	C1309.146851,561.655884 1307.338501,561.571350 1305.218262,561.265503 
	C1306.721313,561.122803 1308.536133,561.201477 1310.653076,561.510315 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1170.148560,866.934448 
	C1171.543945,866.660095 1173.350952,866.412048 1175.552734,866.223938 
	C1174.281372,867.541748 1172.366089,866.815857 1170.148560,866.934448 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1119.047119,780.241516 
	C1119.324219,781.614197 1119.581787,783.390930 1119.789917,785.561096 
	C1118.448242,784.326477 1119.193115,782.424927 1119.047119,780.241516 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1171.759766,559.046936 
	C1170.386963,559.322632 1168.611206,559.578613 1166.443848,559.775391 
	C1167.687134,558.458740 1169.579956,559.189880 1171.759766,559.046936 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1061.488525,1053.656494 
	C1061.314697,1052.142334 1061.369629,1050.331055 1061.707764,1048.259399 
	C1061.899780,1049.785889 1061.808594,1051.572632 1061.488525,1053.656494 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1303.357178,549.508484 
	C1304.858032,549.360596 1306.663940,549.437195 1308.781494,549.734863 
	C1307.282715,549.881653 1305.472534,549.807312 1303.357178,549.508484 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1054.469238,1349.663086 
	C1054.326538,1348.151733 1054.420166,1346.341187 1054.734985,1344.218628 
	C1054.872681,1345.725708 1054.789062,1347.544800 1054.469238,1349.663086 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1066.491943,1343.353882 
	C1066.636597,1344.568726 1066.556763,1346.085815 1066.284424,1347.932495 
	C1066.150513,1346.726807 1066.208984,1345.191406 1066.491943,1343.353882 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1053.489868,1360.655029 
	C1053.347534,1359.435547 1053.435425,1357.916870 1053.715698,1356.068359 
	C1053.845459,1357.277710 1053.782715,1358.816772 1053.489868,1360.655029 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1182.285400,865.968994 
	C1183.339478,865.692871 1184.772583,865.429871 1186.576538,865.225403 
	C1185.665894,866.413391 1184.112305,865.874390 1182.285400,865.968994 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1065.528564,1354.341064 
	C1065.669678,1355.592285 1065.572388,1357.146851 1065.289795,1359.053711 
	C1065.166382,1357.818726 1065.228271,1356.231567 1065.528564,1354.341064 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1063.510254,1377.345459 
	C1063.652588,1378.564941 1063.564819,1380.083740 1063.284546,1381.932373 
	C1063.154663,1380.723022 1063.217285,1379.183838 1063.510254,1377.345459 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1052.524414,1371.642822 
	C1052.378662,1370.448730 1052.449951,1368.955078 1052.727173,1367.150391 
	C1052.869141,1368.340698 1052.805298,1369.841919 1052.524414,1371.642822 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1105.524414,598.642578 
	C1105.378784,597.448425 1105.450073,595.954834 1105.727295,594.150146 
	C1105.869263,595.340393 1105.805420,596.841797 1105.524414,598.642578 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1064.475586,1366.356934 
	C1064.621216,1367.551270 1064.549683,1369.045044 1064.272583,1370.850098 
	C1064.130859,1369.659790 1064.194702,1368.158081 1064.475586,1366.356934 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1050.489746,1394.655029 
	C1050.347534,1393.435547 1050.435425,1391.916870 1050.715576,1390.068359 
	C1050.845337,1391.277710 1050.782593,1392.816772 1050.489746,1394.655029 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1061.475586,1400.356934 
	C1061.621460,1401.551270 1061.550171,1403.045166 1061.272949,1404.850098 
	C1061.130859,1403.659790 1061.194702,1402.158081 1061.475586,1400.356934 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1049.524414,1405.642822 
	C1049.378662,1404.448730 1049.450073,1402.955078 1049.727173,1401.150391 
	C1049.869141,1402.340698 1049.805298,1403.841919 1049.524414,1405.642822 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1060.510254,1411.345459 
	C1060.652588,1412.564941 1060.564819,1414.083740 1060.284546,1415.932373 
	C1060.154663,1414.723022 1060.217285,1413.183838 1060.510254,1411.345459 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1047.489746,1428.655029 
	C1047.347534,1427.435547 1047.435425,1425.916870 1047.715576,1424.068359 
	C1047.845337,1425.277710 1047.782715,1426.816772 1047.489746,1428.655029 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1058.493652,1434.348389 
	C1058.637207,1435.547363 1058.557983,1437.042969 1058.272949,1438.850098 
	C1058.135010,1437.656006 1058.203003,1436.150513 1058.493652,1434.348389 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1046.524414,1439.642822 
	C1046.378784,1438.448730 1046.450073,1436.955078 1046.727051,1435.150391 
	C1046.869019,1436.340698 1046.805176,1437.841919 1046.524414,1439.642822 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1057.508057,1445.352295 
	C1057.651855,1446.598267 1057.563232,1448.150513 1057.289551,1450.054443 
	C1057.161621,1448.823486 1057.218628,1447.240967 1057.508057,1445.352295 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1045.542969,1450.635254 
	C1045.395264,1449.455811 1045.457275,1447.978271 1045.737793,1446.203857 
	C1045.888428,1447.383667 1045.820557,1448.860596 1045.542969,1450.635254 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1158.005615,548.921570 
	C1159.126343,548.640747 1160.657349,548.387085 1162.575439,548.183289 
	C1161.601318,549.452698 1159.956665,548.870300 1158.005615,548.921570 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1197.613281,1471.450928 
	C1196.346802,1471.653931 1194.760864,1471.641479 1192.859619,1471.375000 
	C1194.127441,1471.159424 1195.710693,1471.197510 1197.613281,1471.450928 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1219.602539,1472.418457 
	C1218.407715,1472.570679 1216.900513,1472.522339 1215.066528,1472.282715 
	C1216.256592,1472.133667 1217.773438,1472.175659 1219.602539,1472.418457 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1373.952637,612.774902 
	C1373.666504,611.705078 1373.400146,610.248230 1373.183350,608.415100 
	C1374.431152,609.326721 1373.874023,610.913086 1373.952637,612.774902 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1120.047363,792.223694 
	C1120.323853,793.293152 1120.580688,794.748169 1120.789062,796.578918 
	C1119.578735,795.657776 1120.123047,794.081055 1120.047363,792.223694 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1108.934082,799.866333 
	C1108.649902,798.774841 1108.391724,797.287598 1108.183350,795.419617 
	C1109.439453,796.357971 1108.873901,797.967773 1108.934082,799.866333 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1386.489624,787.360596 
	C1386.635620,788.601624 1386.555054,790.151672 1386.289673,792.053101 
	C1386.157715,790.826233 1386.210449,789.247925 1386.489624,787.360596 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1385.030762,610.288696 
	C1385.943848,611.223450 1385.729370,612.752502 1385.816528,614.587830 
	C1384.568604,613.696472 1385.130737,612.124390 1385.030762,610.288696 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1058.506348,1303.651489 
	C1058.362915,1302.452881 1058.442017,1300.957275 1058.727051,1299.150635 
	C1058.864990,1300.344482 1058.796997,1301.849487 1058.506348,1303.651489 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1069.491943,1309.353882 
	C1069.636353,1310.568848 1069.556274,1312.086060 1069.284180,1313.932617 
	C1069.150513,1312.726807 1069.208984,1311.191406 1069.491943,1309.353882 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1068.508057,1320.352295 
	C1068.651978,1321.598145 1068.563599,1323.150146 1068.290039,1325.054199 
	C1068.161743,1323.823486 1068.218628,1322.240967 1068.508057,1320.352295 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1375.510254,789.639282 
	C1375.364136,788.397888 1375.444824,786.847473 1375.710449,784.945557 
	C1375.842529,786.172791 1375.789795,787.751526 1375.510254,789.639282 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1107.934082,788.870361 
	C1107.661865,787.778259 1107.415649,786.294434 1107.238525,784.434448 
	C1108.410645,785.401001 1107.882080,786.984497 1107.934082,788.870361 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1056.491943,1326.648193 
	C1056.348389,1325.402466 1056.437012,1323.850464 1056.710327,1321.947021 
	C1056.838135,1323.177612 1056.781250,1324.759888 1056.491943,1326.648193 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1067.475586,1332.356934 
	C1067.621216,1333.551270 1067.549683,1335.045044 1067.272705,1336.850098 
	C1067.130981,1335.659790 1067.194824,1334.158081 1067.475586,1332.356934 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1055.524414,1337.642822 
	C1055.378662,1336.448730 1055.449951,1334.955078 1055.727173,1333.150391 
	C1055.869141,1334.340698 1055.805298,1335.841919 1055.524414,1337.642822 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1109.969116,809.738464 
	C1109.698853,808.979065 1109.441895,807.865601 1109.246094,806.404785 
	C1110.228516,807.025269 1109.955566,808.235168 1109.969116,809.738464 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1142.672607,878.532227 
	C1141.728638,878.673523 1140.494507,878.580078 1138.929810,878.297241 
	C1139.860352,878.171082 1141.121460,878.234253 1142.672607,878.532227 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1214.482910,883.678833 
	C1214.349731,882.778809 1214.440063,881.601868 1214.731445,880.132202 
	C1214.857300,881.026978 1214.781860,882.214478 1214.482910,883.678833 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1121.080322,802.984863 
	C1121.351440,803.804504 1121.594971,805.011536 1121.789551,806.586914 
	C1120.730591,805.910767 1121.052124,804.610657 1121.080322,802.984863 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1106.464844,588.681030 
	C1106.328003,587.760681 1106.422852,586.559448 1106.712524,585.049316 
	C1106.837036,585.960266 1106.766846,587.180176 1106.464844,588.681030 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1385.498291,798.330322 
	C1385.634033,799.225708 1385.551880,800.400574 1385.268311,801.867981 
	C1385.138184,800.976929 1385.209351,799.793335 1385.498291,798.330322 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1374.485352,799.671509 
	C1374.347412,798.756287 1374.435425,797.557190 1374.715332,796.048645 
	C1374.841919,796.955383 1374.776611,798.171509 1374.485352,799.671509 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1123.031006,820.265442 
	C1123.318359,821.024109 1123.592529,822.141724 1123.816895,823.610474 
	C1122.765015,823.018127 1123.045776,821.786560 1123.031006,820.265442 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1315.346191,550.521973 
	C1316.250977,550.381653 1317.444824,550.455811 1318.948975,550.718628 
	C1318.051392,550.850281 1316.843262,550.793335 1315.346191,550.521973 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1329.675049,563.499939 
	C1328.786987,563.634216 1327.624756,563.552002 1326.184814,563.257080 
	C1327.071655,563.124084 1328.236328,563.203796 1329.675049,563.499939 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1324.327271,551.467773 
	C1325.270874,551.328186 1326.504517,551.423279 1328.069580,551.705322 
	C1327.139648,551.828979 1325.878540,551.765747 1324.327271,551.467773 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1320.644775,562.475464 
	C1319.716064,562.618713 1318.489258,562.544678 1316.930176,562.288818 
	C1317.847412,562.157410 1319.097046,562.207764 1320.644775,562.475464 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1226.535156,879.319092 
	C1226.670288,880.238892 1226.573608,881.439758 1226.284790,882.950684 
	C1226.162964,882.040527 1226.233154,880.820312 1226.535156,879.319092 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1159.800293,560.047607 
	C1159.026733,560.322693 1157.891602,560.578247 1156.404053,560.775024 
	C1157.033325,559.761414 1158.266602,560.045349 1159.800293,560.047607 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1225.517212,888.321289 
	C1225.650391,889.221558 1225.560059,890.398621 1225.268433,891.868652 
	C1225.142700,890.973755 1225.218140,889.785950 1225.517212,888.321289 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1213.464844,892.681030 
	C1213.329712,891.761414 1213.426514,890.560913 1213.715210,889.050476 
	C1213.837036,889.960388 1213.766846,891.180237 1213.464844,892.681030 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1224.500000,897.324890 
	C1224.634277,898.213013 1224.552002,899.375305 1224.256958,900.815308 
	C1224.123901,899.928406 1224.203735,898.763672 1224.500000,897.324890 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1122.066650,812.112732 
	C1122.350830,812.905884 1122.608643,814.072937 1122.816895,815.600830 
	C1121.745239,814.966309 1122.047729,813.694092 1122.066650,812.112732 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1192.262451,864.968872 
	C1193.021240,864.697510 1194.135620,864.439392 1195.599121,864.232483 
	C1194.988281,865.231812 1193.771240,864.954468 1192.262451,864.968872 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1211.500244,909.674927 
	C1211.366089,908.786926 1211.448364,907.624878 1211.743408,906.185059 
	C1211.876221,907.071899 1211.796387,908.236328 1211.500244,909.674927 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1186.017334,877.080078 
	C1185.196167,877.348633 1183.990723,877.589722 1182.421387,877.761658 
	C1183.116699,876.737854 1184.402832,877.051025 1186.017334,877.080078 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1222.535156,914.319092 
	C1222.670288,915.238892 1222.573486,916.439758 1222.284668,917.950684 
	C1222.162964,917.040527 1222.233154,915.820312 1222.535156,914.319092 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1210.482910,918.678833 
	C1210.349854,917.778809 1210.440063,916.601868 1210.731445,915.132202 
	C1210.857300,916.026978 1210.781860,917.214478 1210.482910,918.678833 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1221.517212,923.321289 
	C1221.650391,924.221558 1221.560059,925.398621 1221.268433,926.868652 
	C1221.142700,925.973755 1221.218262,924.785950 1221.517212,923.321289 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1211.733887,874.031006 
	C1210.975098,874.318359 1209.857666,874.592468 1208.388794,874.816772 
	C1208.981201,873.765259 1210.212646,874.045532 1211.733887,874.031006 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1110.933105,817.885681 
	C1110.648926,817.093079 1110.390991,815.926697 1110.183105,814.399170 
	C1111.254150,815.033142 1110.952637,816.304749 1110.933105,817.885681 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1203.796875,875.047424 
	C1203.023804,875.333618 1201.886108,875.600220 1200.392822,875.816895 
	C1201.003052,874.757690 1202.250854,875.045593 1203.796875,875.047424 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1195.738525,876.031006 
	C1194.979126,876.301086 1193.865601,876.558044 1192.404785,876.753784 
	C1193.025269,875.770996 1194.235352,876.044922 1195.738525,876.031006 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1227.481323,871.331055 
	C1227.619995,871.967773 1227.546997,872.879883 1227.292603,874.093872 
	C1227.164062,873.465942 1227.216797,872.536194 1227.481323,871.331055 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1201.082397,863.932129 
	C1201.588745,863.669495 1202.435303,863.433350 1203.612915,863.252197 
	C1203.234741,864.032104 1202.331177,864.005127 1201.082397,863.932129 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1384.083130,601.960938 
	C1384.346924,602.490540 1384.581787,603.376221 1384.754639,604.602905 
	C1383.949707,604.197083 1383.998413,603.257874 1384.083130,601.960938 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1333.322876,552.500854 
	C1333.963623,552.363037 1334.877197,552.442383 1336.093018,552.705200 
	C1335.462036,552.831787 1334.528931,552.774963 1333.322876,552.500854 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1208.963379,862.916992 
	C1209.491333,862.650940 1210.379150,862.413635 1211.612061,862.217712 
	C1211.223511,863.042114 1210.275391,863.001526 1208.963379,862.916992 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1149.082886,549.932251 
	C1149.589111,549.669739 1150.435669,549.433655 1151.613037,549.252441 
	C1151.234863,550.032043 1150.331543,550.005188 1149.082886,549.932251 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1216.086060,861.932007 
	C1216.590332,861.662231 1217.438721,861.418884 1218.622070,861.217346 
	C1218.261353,862.021912 1217.349854,862.005249 1216.086060,861.932007 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1384.521729,806.302185 
	C1384.653809,806.927612 1384.566772,807.812012 1384.287109,808.976074 
	C1384.163818,808.357483 1384.233276,807.459351 1384.521729,806.302185 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1372.916748,603.037781 
	C1372.651855,602.509094 1372.415771,601.622559 1372.231445,600.392944 
	C1373.046753,600.789917 1373.001465,601.733582 1372.916748,603.037781 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1124.067871,828.086304 
	C1124.337891,828.590454 1124.581177,829.438538 1124.782715,830.621582 
	C1123.977295,830.261292 1123.995483,829.349609 1124.067871,828.086304 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1112.951660,831.825684 
	C1112.679810,831.339661 1112.427490,830.519653 1112.217285,829.371582 
	C1113.008911,829.710632 1113.006348,830.596375 1112.951660,831.825684 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1150.913940,561.067993 
	C1150.409668,561.337830 1149.561279,561.581177 1148.377930,561.782715 
	C1148.738647,560.978088 1149.650146,560.994751 1150.913940,561.067993 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1117.503174,587.310669 
	C1117.634399,587.932007 1117.552124,588.814697 1117.282227,589.976929 
	C1117.159546,589.361694 1117.224731,588.466919 1117.503174,587.310669 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1107.475464,580.706726 
	C1107.349487,580.092346 1107.439697,579.227844 1107.731079,578.101929 
	C1107.852051,578.712524 1107.771851,579.584595 1107.475464,580.706726 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1111.916870,825.033691 
	C1111.636108,824.506470 1111.384155,823.617737 1111.182617,822.383179 
	C1112.037476,822.762268 1112.001587,823.714539 1111.916870,825.033691 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1337.686523,564.518188 
	C1337.041382,564.653503 1336.125366,564.566101 1334.906738,564.295044 
	C1335.541260,564.172668 1336.478516,564.234009 1337.686523,564.518188 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1355.087524,925.950989 
	C1355.315796,926.489807 1355.515137,927.400818 1355.778076,928.662659 
	C1354.993286,928.287720 1354.996338,927.314026 1355.087524,925.950989 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1223.481201,906.331055 
	C1223.619873,906.967773 1223.546875,907.879883 1223.292480,909.093872 
	C1223.164185,908.465942 1223.216919,907.536194 1223.481201,906.331055 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1212.518799,900.669006 
	C1212.380127,900.032532 1212.453125,899.120789 1212.707275,897.907349 
	C1212.835693,898.535034 1212.783081,899.464417 1212.518799,900.669006 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1371.968750,595.766846 
	C1371.705444,595.292175 1371.455322,594.491882 1371.244263,593.370483 
	C1371.516113,593.846619 1371.749023,594.643921 1371.968750,595.766846 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1383.083130,594.966309 
	C1383.363892,595.493530 1383.615723,596.382263 1383.817383,597.616821 
	C1382.962524,597.237732 1382.998413,596.285461 1383.083130,594.966309 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1382.097412,588.909302 
	C1382.347290,589.167603 1382.571655,589.747009 1382.756592,590.639893 
	C1382.501953,590.379089 1382.286865,589.804749 1382.097412,588.909302 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1115.960693,847.812012 
	C1115.720459,847.598633 1115.485596,847.105774 1115.283203,846.333801 
	C1115.532471,846.547302 1115.749146,847.039978 1115.960693,847.812012 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1126.036865,840.177612 
	C1126.258301,840.395264 1126.471680,840.882446 1126.634888,841.640015 
	C1126.399536,841.422729 1126.214233,840.934937 1126.036865,840.177612 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1113.962036,837.817261 
	C1113.723511,837.600891 1113.491699,837.110291 1113.315063,836.345825 
	C1113.569702,836.562378 1113.769165,837.052795 1113.962036,837.817261 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1125.097412,834.908752 
	C1125.347534,835.167175 1125.571899,835.746704 1125.756836,836.639954 
	C1125.502075,836.379028 1125.286865,835.804504 1125.097412,834.908752 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1373.649902,805.655945 
	C1373.531250,805.345947 1373.558105,804.822083 1373.770142,804.103149 
	C1373.902100,804.419373 1373.848877,804.930786 1373.649902,805.655945 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1370.916382,588.980042 
	C1370.662720,588.739624 1370.431519,588.194214 1370.241699,587.347473 
	C1370.501587,587.589111 1370.720215,588.132080 1370.916382,588.980042 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1118.474121,581.277466 
	C1118.585938,581.616394 1118.513550,582.170654 1118.254883,582.941406 
	C1118.142456,582.602905 1118.216064,582.047852 1118.474121,581.277466 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1354.740234,567.496582 
	C1354.402344,567.600220 1353.858887,567.515930 1353.112061,567.238403 
	C1353.450684,567.132935 1353.992798,567.220764 1354.740234,567.496582 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1349.721680,566.473755 
	C1349.382812,566.585815 1348.828613,566.513367 1348.058105,566.254700 
	C1348.396729,566.142090 1348.951538,566.215698 1349.721680,566.473755 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1343.699463,565.448853 
	C1343.356934,565.570862 1342.786011,565.511841 1341.981201,565.274536 
	C1342.322021,565.153503 1342.896484,565.210693 1343.699463,565.448853 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1142.040283,550.925781 
	C1142.281860,550.690735 1142.816528,550.477600 1143.639404,550.317383 
	C1143.396240,550.562805 1142.864868,550.755249 1142.040283,550.925781 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1144.092285,562.096924 
	C1143.833984,562.347107 1143.254272,562.571655 1142.360962,562.756592 
	C1142.621826,562.501709 1143.196411,562.286499 1144.092285,562.096924 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1341.300293,553.551270 
	C1341.642822,553.429321 1342.213623,553.488342 1343.018066,553.725647 
	C1342.677490,553.846680 1342.103027,553.789490 1341.300293,553.551270 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1138.982910,563.078186 
	C1139.033569,563.328674 1138.825684,563.473938 1138.351196,563.444702 
	C1138.350342,563.226807 1138.563721,563.127686 1138.982910,563.078186 
z"
      />
      <path
        fill="#B8D2AF"
        opacity="1.000000"
        stroke="none"
        d="
M802.351440,1613.040039 
	C802.136536,1612.878906 802.169861,1612.688110 802.217163,1612.207153 
	C802.445129,1612.142456 802.681519,1612.352905 802.854858,1612.606323 
	C802.890442,1612.658447 802.690796,1612.871338 802.351440,1613.040039 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1348.333618,554.714722 
	C1348.431519,554.456848 1348.696533,554.451294 1349.108398,554.751526 
	C1349.251831,554.902100 1348.868896,554.904968 1348.868896,554.904968 
	C1348.868896,554.904968 1348.497559,554.811951 1348.333618,554.714722 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1139.358398,866.717590 
	C1139.455322,866.457214 1139.743652,866.441711 1140.207275,866.723877 
	C1140.374878,866.875549 1139.954712,866.896545 1139.954712,866.896545 
	C1139.954712,866.896545 1139.541870,866.816467 1139.358398,866.717590 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1114.922119,842.982971 
	C1114.671631,843.033630 1114.526489,842.825806 1114.555786,842.351318 
	C1114.773560,842.350586 1114.872559,842.563843 1114.922119,842.982971 
z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
M1383.285278,814.333496 
	C1383.543213,814.431274 1383.548828,814.696350 1383.248413,815.108276 
	C1383.063965,814.992737 1383.093994,814.741211 1383.285278,814.333496 
z"
      />
      <path
        fill="#FAFCF9"
        opacity="1.000000"
        stroke="none"
        d="
M1587.737061,501.800659 
	C1598.029785,494.959564 1598.030518,494.958557 1608.097656,501.693115 
	C1610.977417,503.619629 1613.852173,505.553772 1617.337036,507.892273 
	C1610.053345,512.067810 1603.181030,515.979126 1596.343384,519.950195 
	C1594.863892,520.809509 1593.922241,520.126770 1592.828247,519.235535 
	C1588.332153,515.572876 1583.788818,511.968506 1578.689819,507.883545 
	C1581.830688,505.769867 1584.632935,503.884125 1587.737061,501.800659 
z"
      />
      <path
        fill="#F9FBF9"
        opacity="1.000000"
        stroke="none"
        d="
M958.459717,1427.237305 
	C956.704651,1428.468262 955.431458,1428.849487 953.781311,1427.445190 
	C949.867798,1424.114502 945.825012,1420.928589 941.733521,1417.817017 
	C939.825623,1416.365845 939.981323,1415.516968 941.934937,1414.270630 
	C946.961121,1411.063721 951.892212,1407.707275 956.839844,1404.378662 
	C957.990845,1403.604248 958.982483,1403.040771 960.397400,1404.007446 
	C966.090088,1407.897095 971.846252,1411.693726 978.194397,1415.936157 
	C971.312805,1419.880615 965.041565,1423.475342 958.459717,1427.237305 
z"
      />
      <path
        fill="#FAFCF9"
        opacity="1.000000"
        stroke="none"
        d="
M1578.811035,1440.169922 
	C1572.339355,1434.886475 1572.283569,1434.799316 1578.896240,1430.564453 
	C1583.195801,1427.811035 1587.190552,1422.591064 1591.848511,1422.949341 
	C1596.212158,1423.284912 1600.254883,1427.859985 1604.427246,1430.587158 
	C1606.366943,1431.854858 1608.279419,1433.164551 1610.960083,1434.961914 
	C1603.515015,1439.200195 1596.517456,1443.160034 1589.548950,1447.170410 
	C1588.140625,1447.980835 1587.397095,1446.956787 1586.531128,1446.282593 
	C1584.034790,1444.339355 1581.572510,1442.352539 1578.811035,1440.169922 
z"
      />
      <path
        fill="#FAFCF9"
        opacity="1.000000"
        stroke="none"
        d="
M972.780273,537.973267 
	C973.751526,538.816284 975.471924,539.290527 973.442627,540.443787 
	C966.964661,544.125122 960.497314,547.825195 954.043152,551.548035 
	C952.858032,552.231628 951.917480,552.041077 950.891968,551.203430 
	C946.170349,547.346985 941.412598,543.534729 936.384888,539.478333 
	C942.371521,535.474792 948.073303,531.800598 953.606689,527.888000 
	C955.611084,526.470703 956.901306,527.339355 958.455139,528.394897 
	C963.113403,531.559509 967.804810,534.675293 972.780273,537.973267 
z"
      />
    </svg>
  );
};

PurposeAndBalanceIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

PurposeAndBalanceIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default PurposeAndBalanceIllustration;
